import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {ConfService} from '../conf.service';
import {Observable} from 'rxjs';
import {ICategory} from '../crudapi/crudapi.component';
import {FormControl} from '@angular/forms';
import {NgxXml2jsonService} from 'ngx-xml2json';
import {environment} from '../../environments/environment';
import {MatDialog, MatSnackBar} from '@angular/material';
import {KongService} from '../kong.service';
import {ActivatedRoute} from "@angular/router";
import { HeadersComponent } from '../devex/headers/headers.component';
import {AppComponent} from '../app.component';
import {AuthorizationComponent} from '../authorization/authorization.component';
import {EntityVersionChangeConfirmationComponent} from '../edit-entity/edit-entity.component';
import {ConnecttocrudService} from '../connecttocrud.service';
import { DialogComponent } from '../shared/dialog/dialog.component';
import {Router} from '@angular/router';
import {PartnerOnboardComponent} from "../partner-onboard/partner-onboard.component";
import {ListenerService} from '../listener.service';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {BusinesslogicListenerService} from '../businesslogic-listener.service';
import {Location} from '@angular/common';
const incr = 5;
declare let Blockly;
declare let $;
@Component({
  selector: 'app-edit-blockly',
  templateUrl: './edit-blockly.component.html',
  styleUrls: ['./edit-blockly.component.scss']
})

export class EditBlocklyComponent implements AfterViewInit, OnInit {

  @ViewChild(HeadersComponent) devexHeader: HeadersComponent;

  save: boolean;
  workspace: any;
  application: any;
  @Input() executors: any;
  items: any;
  attributes: any;
  addTo: any;
  apiConnectors: any;
  attributeList = [];
  firstOfBody = [];
  addToList = [];
  apiConnectorList = [];
  executorList = [];
  apiResponseFromServerForB2B: any;
  apiResponseFromServerForMyProviders: any;
  entityName = [];
  blocklyXMLToolbox: any;
  simplifiedJsonForb2b = [];
  executorVersions = [
    {name: 'v1'},
    {name: 'v2'},
    {name: 'v3'},
    {name: 'v4'},
    {name: 'v5'},
    {name: 'v6'},
    {name: 'v7'},
    {name: 'v8'},
    {name: 'v9'},
    {name: 'v10'}
  ];
  authModel = {
    'authType': '',
    'authAttributes': {}
  };
  @ViewChild (AuthorizationComponent) authModel1: AuthorizationComponent;

  headers = [];
  queryParams = [];
  requestBody = {};
  prerequisites: any;
  responseAttributes = [];
  executorMethods = [
    {name: 'GET'},
    {name: 'POST'},
    {name: 'PUT'},
    {name: 'DELETE'},
    {name: 'PATCH'}
  ];
  blocklyDivSize = 'col-md-12 col-lg-12';
  debugErrorFlag = false;
  debugResult: any;
  debugVariables = [];
  inputSet: any;
  searchText: any;
  results: any;
  debugResults: any;
  isError = false;
  errorClass: string;
  errorMessage: string;
  logText: string;
  errorStackTrace: [];
  executorBlocks: any;
  executorTypes = [
    // {'displayName': 'Simple API', 'value': 'API'},
    {'displayName': 'Business Logic API', 'value': 'BUSINESSLOGIC'},
    // {'displayName': 'Data Access API', 'value': 'DATAACCESS'},
    // {'displayName': 'Third Party API', 'value': 'THIRDPARTY'}
  ];

  scope = [{'displayName': 'Public', 'value': 'public'},
    {'displayName': 'Private', 'value': 'private'}];
  scopeSelected = 'public';
  description: string;
  executorCategory: string;
  executor_name: string;
  executor_type: string;
  selectedVersion: string;
  selectedExecutor: string;
  currentEntityName: string;
  selectedExecutorType = 'BUSINESSLOGIC';
  executor_display_name: string;
  searchAPI: any;

  databases: any;
  sqlDatabases = [['Select a SQL Database', '']];
  apiResponse: any;
  sqlOperations: any;
  parallel: any;
  filteredOptions: Observable<ICategory[]>;
  myControl = new FormControl();
  destroy: any;
  Blocks = [];
  BlockList = {
    '1': 0,
    '2': 25,
    '3': 50,
    '4': 75,
    '5': 100
  };
  progress = 0;
  progressMessage: string;
  showNextPanel = false;
  @Input() entity: string;
  @Input() emitSaveApi = false;
  @Input() version: string;
  @Input() partner = localStorage.getItem('partner');
  partnerKey = localStorage.getItem('partnerKey');
  @Input() account_id = localStorage.getItem('account');
  apiKey = localStorage.getItem('apikey');
  url = environment.konghost;
  servicedata: any;
  routehostdata: any;
  routepathdata: any;
  ratelimitingOrig: any;
  keyauthOrig: any;

  executor: any;
  editFlag = false;
  @Input() showButtons = true;
  debugFlag = false;
  gatewayUrl: any; // = (this.partner === this.account ? 'gateway.' + this.partner + '.apiplatform.io' : 'gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
  gatewayFullUrl: string; // = 'https://' + this.gatewayUrl;

  @Input() orig_executor_name: string;
  @Input() orig_executor_version: string;
  @Input() workSpaceId = 'blocklyDiv';
  @Output() blocklyRendered: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveBlocks: EventEmitter<any> = new EventEmitter<any>();

  orig_executor_method_type: string;
  orig_executor_parameters: any;
  @Input() orig_executor: any;
  orig_executor_request_body: any;
  orig_executor_authModel: any;

  authorizationBlocks: any;

  loading = false;
  loading1 = false;

  samplesInPartner = false;
  cloneable = false;
  registeredConnectors: any;
  @ViewChild('toolbox') toolbox: ElementRef;
  eventNameForAudit = '';
  xml_content: any;
  isFromHistory = false;
  historyData: any;
  previousSavedData: any;
  partnerEntities: any;
  partnerExecutors: any;
  isAPIAlreadyPresent: boolean;
  isAPIAlreadyPresentCheckCompleted = false;
  previouslyCheckedName: any;
  previouslyCheckedVersion: any;
  isToggleExpanded = false;
  route: any;
  executeFlagLocally: boolean;
  historyTimestamp: any;
  businessLogicEdit: boolean;
  providerObjects = {};

  constructor(
      private router: Router,
      private _route: ActivatedRoute,
      private cfgSrv: ConfService, private kongService: KongService, private _service: ConnecttocrudService,
      public snackBar: MatSnackBar,
      private appComp: AppComponent,
      public dialog: MatDialog,
      public settingComp: PartnerOnboardComponent,
      private leftPanelDataListener: ListenerService,
      public platform: LeftpanelComponent,
      private businessLogicListenerInstance: BusinesslogicListenerService,
      private location: Location,
      private ngxXml2jsonService: NgxXml2jsonService) {
    this.route = this.location.path();
    _route.queryParams
        .subscribe(async params => {
          this.cloneable = false;
          this.isFromHistory = false;
          this.businessLogicEdit = false;
          if (params) {
            if (params.clone && params.clone === 'true') {
              this.cloneable = true;
              this.businessLogicEdit = false;
              this.isFromHistory = false;
              if (this.platform.cloneableData !== undefined) {
                this.entity = this.platform.cloneableData['executor_name'];
                this.version = this.platform.cloneableData['executor_version'];
                this.orig_executor_name = this.platform.cloneableData['executor_name'];
                this.orig_executor_version = this.platform.cloneableData['executor_version'];
                this.editFlag = false;
              } else {
                this.editFlag = false;
                this.router.navigateByUrl('/businesslogic');
              }
            } else if (params.timestamp && params.timestamp !== null && params.timestamp !== undefined) {
              this.businessLogicEdit = false;
              this.historyTimestamp = params.timestamp;
              this.isFromHistory = true;
              this.cloneable = false;
              this.partner = params.partner;
              this.account_id = params.account;
              this.getHistory(params.partner, params.account, params.timestamp);
            } else if (params.entity && params.version) {
              this.businessLogicEdit = true;
              this.isFromHistory = false;
              this.cloneable = false;
              this.entity = params.entity;
              this.version = params.version;
              this.orig_executor_name = params.entity;
              this.orig_executor_version = params.version;
              this.editFlag = true;
              this.orig_executor = undefined;
              this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(data => {
                if (data != null) {
                  this.orig_executor = data;
                }
              });
            } else {
              this.editFlag = false;
              this.businessLogicEdit = false;
              this.isFromHistory = false;
              this.cloneable = false;
              this.selectedExecutorType = 'BUSINESSLOGIC';
              this.executor_name = undefined;
              this.selectedVersion = undefined;
              this.executor_display_name = undefined;
              this.description = undefined;
              this.executorCategory = undefined;
              this.scopeSelected = 'public';
              this.selectedExecutor = undefined;
              this.queryParams = [];
              this.headers = [];
              this.requestBody = [];
              this.attributeList = [];
            }
            const that = this;
            // if (this.entity && this.version) {
            //     this.editFlag = true;
            // }
            if (this.attributeList !== null && this.attributeList !== undefined) {
              this.attributeList.push(['Select Target Attributes', 'null'],
                  ['API.name', 'API.name'],
                  ['API.version', 'API.version'],
                  ['API.methodType', 'API.methodType'],
                  ['API.type', 'API.type'],
                  ['Headers', 'Headers'],
                  ['Parameters', 'Parameters'],
                  ['Payload', 'Payload'],
                  ['Authorization', 'Authorization']);
            } else {
              // this.attributeList = [];
              // this.attributeList.push(
              //     ['Select Target Attributes', 'null'],
              //     ['API.name', 'API.name'],
              //     ['API.version', 'API.version'],
              //     ['API.methodType', 'API.methodType'],
              //     ['API.type', 'API.type'],
              //     ['Headers', 'Headers'],
              //     ['Parameters', 'Parameters'],
              //     ['Authorization', 'Authorization']);
              if (this.attributeList.findIndex(p => p[0] === 'Select Target Attributes') === -1) {
                this.attributeList.push(['Select Target Attributes', 'null']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'API.name') === -1) {
                this.attributeList.push(['API.name', 'API.name']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'API.version') === -1) {
                this.attributeList.push(['API.version', 'API.version']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'API.methodType') === -1) {
                this.attributeList.push(['API.methodType', 'API.methodType']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'API.type') === -1) {
                this.attributeList.push(['API.type', 'API.type']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'Headers') === -1) {
                this.attributeList.push(['Headers', 'Headers']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'Parameters') === -1) {
                this.attributeList.push(['Parameters', 'Parameters']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'Authorization') === -1) {
                this.attributeList.push(['Authorization', 'Authorization']);
              }
            }
            this.addToList.push(['Headers', 'Headers'], ['Parameters', 'Parameters']);
            this.attributes = function() {
              return that.loadAttributes();
            };
            this.addTo = function() {
              return that.loadAddToAttributes();
            };
            this.apiConnectors = function() {
              return that.loadApiConnectors();
            };
            this.apiResponse = function() {
              return that.loadResponse();
            };
            this.sqlOperations = function() {
              return that.loadSqlOperations();
            };
            this.parallel = function() {
              return that.loadParallel();
            };

            const textWorkspace = new Blockly.Workspace();

            // this.executors = function() {
            //     return that.loadExecutorBlocks();
            // };
            // this.gatewayUrl = (this.partner === this.account ? 'gateway.' + this.partner + '.apiplatform.io' : 'gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
            this.gatewayUrl = await this.platform.getDefaultGatewayURL();
            this.gatewayFullUrl = 'https://' + this.gatewayUrl;
            if (this.platform.authorizationTypes !== null && this.platform.authorizationTypes !== undefined) {
              this.authorizationBlocks = this.platform.authorizationTypes;
            } else {
              this._service.getItems('v1', 'services', 'services', 'authorizationTypes', false).subscribe(authTypes => {
                this.authorizationBlocks = authTypes;
                this.platform.authorizationTypes = authTypes;
              });
            }
          } else {
            this.editFlag = false;
          }
        });

    this.businessLogicEdit = true;
    this.isFromHistory = false;
    this.cloneable = false;
    //this.entity = params.entity;
    //this.version = params.version;
    //this.orig_executor_name = params.entity;
    //this.orig_executor_version = params.version;
    this.editFlag = true;
    //this.orig_executor = undefined;
    // this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(data => {
    //   if (data != null) {
    //     this.orig_executor = data;
    //   }
    // });
    const that = this;
    if (this.attributeList !== null && this.attributeList !== undefined) {
      this.attributeList.push(['Select Target Attributes', 'null'],
          ['API.name', 'API.name'],
          ['API.version', 'API.version'],
          ['API.methodType', 'API.methodType'],
          ['API.type', 'API.type'],
          ['Headers', 'Headers'],
          ['Parameters', 'Parameters'],
          ['Payload', 'Payload'],
          ['Authorization', 'Authorization']);
    } else {
      // this.attributeList = [];
      // this.attributeList.push(
      //     ['Select Target Attributes', 'null'],
      //     ['API.name', 'API.name'],
      //     ['API.version', 'API.version'],
      //     ['API.methodType', 'API.methodType'],
      //     ['API.type', 'API.type'],
      //     ['Headers', 'Headers'],
      //     ['Parameters', 'Parameters'],
      //     ['Authorization', 'Authorization']);
      if (this.attributeList.findIndex(p => p[0] === 'Select Target Attributes') === -1) {
        this.attributeList.push(['Select Target Attributes', 'null']);
      }
      if (this.attributeList.findIndex(p => p[0] === 'API.name') === -1) {
        this.attributeList.push(['API.name', 'API.name']);
      }
      if (this.attributeList.findIndex(p => p[0] === 'API.version') === -1) {
        this.attributeList.push(['API.version', 'API.version']);
      }
      if (this.attributeList.findIndex(p => p[0] === 'API.methodType') === -1) {
        this.attributeList.push(['API.methodType', 'API.methodType']);
      }
      if (this.attributeList.findIndex(p => p[0] === 'API.type') === -1) {
        this.attributeList.push(['API.type', 'API.type']);
      }
      if (this.attributeList.findIndex(p => p[0] === 'Headers') === -1) {
        this.attributeList.push(['Headers', 'Headers']);
      }
      if (this.attributeList.findIndex(p => p[0] === 'Parameters') === -1) {
        this.attributeList.push(['Parameters', 'Parameters']);
      }
      if (this.attributeList.findIndex(p => p[0] === 'Authorization') === -1) {
        this.attributeList.push(['Authorization', 'Authorization']);
      }
    }
    this.addToList.push(['Headers', 'Headers'], ['Parameters', 'Parameters']);
    this.attributes = function() {
      return that.loadAttributes();
    };
    this.addTo = function() {
      return that.loadAddToAttributes();
    };
    this.apiConnectors = function() {
      return that.loadApiConnectors();
    };
    this.apiResponse = function() {
      return that.loadResponse();
    };
    this.sqlOperations = function() {
      return that.loadSqlOperations();
    };
    this.parallel = function() {
      return that.loadParallel();
    };

    const textWorkspace = new Blockly.Workspace();

    // this.executors = function() {
    //     return that.loadExecutorBlocks();
    // };
    // this.gatewayUrl = (this.partner === this.account ? 'gateway.' + this.partner + '.apiplatform.io' : 'gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
    this.setGatewayURL();
    if (this.platform.authorizationTypes !== null && this.platform.authorizationTypes !== undefined) {
      this.authorizationBlocks = this.platform.authorizationTypes;
    } else {
      this._service.getItems('v1', 'services', 'services', 'authorizationTypes', false).subscribe(authTypes => {
        this.authorizationBlocks = authTypes;
        this.platform.authorizationTypes = authTypes;
      });
    }



  }

  async setGatewayURL() {
    this.gatewayUrl = await this.platform.getDefaultGatewayURL();
    this.gatewayFullUrl = 'https://' + this.gatewayUrl;
  }

  hasViewPagePermissions() {
    if (this.editFlag === true) {
      if (this.isFromHistory === true) {
        return (this.platform.hasPermissions(['EDIT_HISTORY', 'EDIT_BUSINESS_LOGIC_API', 'edit:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]));
      } else {
        return this.platform.hasPermissions(['EDIT_BUSINESS_LOGIC_API', 'edit:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
      }
    } else {
      if (this.isFromHistory === true) {
        return (this.platform.hasPermissions(['EDIT_HISTORY', 'CREATE_BUSINESS_LOGIC_API']));
      } else {
        return this.platform.hasPlatformPermission('CREATE_BUSINESS_LOGIC_API');
      }
    }
  }

  hasTestPermissions() {
    if (this.editFlag === true) {
      return this.platform.hasPermissions(['TEST_BUSINESS_LOGIC_API', 'test:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
    } else {
      return this.platform.hasPlatformPermission('TEST_BUSINESS_LOGIC_API');
    }
  }

  hasSavePermissions() {
    if (this.editFlag === true) {
      return this.platform.hasPermissions(['SAVE_BUSINESS_LOGIC_API', 'save:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
    } else {
      return this.platform.hasPlatformPermission('SAVE_BUSINESS_LOGIC_API');
    }
  }

  hasCopyPermissions() {
    if (this.editFlag === true) {
      return this.platform.hasPermissions(['COPY_BUSINESS_LOGIC_API', 'copy:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
    } else {
      return this.platform.hasPlatformPermission('COPY_BUSINESS_LOGIC_API');
    }
  }

  hasUpdateParamsPermissions() {
    if (this.editFlag === true) {
      return this.platform.hasPermissions(['UPDATE_PARAMS_BUSINESS_LOGIC_API', 'update_params:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
    } else {
      return this.platform.hasPlatformPermission('UPDATE_PARAMS_BUSINESS_LOGIC_API');
    }
  }

  sleep(ms: number = 0) {
    return new Promise(r => setTimeout(r, ms));
  }

  getAPIExecutor() {
    return new Promise((resolve, reject) => {
      this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(data => {
        if (data != null) {
          this.orig_executor = data;
          resolve('success');
        } else {
          resolve('failed');
        }
      }, error => {
        resolve('failed');
      });
    });
  }

  getHistory(partner, account, timestamp) {
    return new Promise((resolve, reject) => {
      this.cfgSrv.getData('services', 'services', 'v1', 'apiHistory', 'partner=' + partner + '&account=' + account + '&at=' + timestamp).subscribe(response => {
        if (response && response !== null && response !== undefined && response[0] && response[0]['executor']) {
          this.entity = response[0]['executor_name'];
          this.version = response[0]['executor_version'];
          this.orig_executor_name = response[0]['executor_name'];
          this.orig_executor_version = response[0]['executor_version'];
          if (response[0]['action'] === 'CREATE') {
            this.editFlag = false;
          } else {
            this.editFlag = true;
          }
          this.isFromHistory = true;
          this.historyData = response[0]['executor'];
          this.orig_executor = response[0]['executor'];
          resolve('success');
        } else {
          resolve('failed');
        }
      }, error => {
        resolve('failed');
      });
    });
  }

  manageProgress(target, showPanel) {
    if (this.progress <= target) {
      // this.showNextPanel = showPanel;
      // this.cfgSrv.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
      //     let item = data;
      // this.kongService.getKeyAuthForConsumerInApiGatewayByNameOrId(item['primary_email']).subscribe(keys => {
      this.save = false;
      let apiKey = localStorage.getItem('apikey');
      const dialogRef = this.dialog.open(DialogComponent, {
        maxWidth: '95vw',
        data: {type: 'bl', save: true, gatewayFullUrl: this.gatewayFullUrl, Blocks: this.Blocks, selectedVersion: this.selectedVersion, showNextPanel: false, partner: this.partner, account: this.account_id, selectedExecutor: this.selectedExecutor, executor_name: this.executor_name, apiKey: apiKey, partnerKey: this.partnerKey}
      });
      dialogRef.afterClosed().subscribe(async result => {
        if (result === 'create') {
          await this.router.navigateByUrl('/businesslogic');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else if (result === 'edit') {
          this.router.navigateByUrl('/businesslogic/edit?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.executor_name + '&version=' + this.selectedVersion);
        } else if (result === 'execute') {
          this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&executor_name=' + this.executor_name + '&executor_version=' + this.selectedVersion);
        } else if (result === 'devex') {
          this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&executor_name=' + this.executor_name + '&executor_version=' + this.selectedVersion + '&showDoc=true');
        }
      });
      // });
      // });
      this.ngOnDestroy();
    } else {
      this.progress = this.progress + incr;
    }
    if (this.progress <= 35) {
      this.progressMessage = 'Setting Up Business Logic API';
    } else if (this.progress > 35 && this.progress <= 70) {
      this.progressMessage = 'Setting Up Database';
    } else if (this.progress > 70) {
      this.progressMessage = 'Deploying into Cloud';
    }
  }

  public getb2bAPIs = async () =>  {
    if (this.platform.b2bExecutors !== null && this.platform.b2bExecutors !== undefined) {
      this.apiResponseFromServerForB2B = this.platform.b2bExecutors;
      this.apiResponseFromServerForMyProviders = this.platform.myProviderExecutors;
      this.providerObjects = this.platform.providerObjects;
    } else {
      await Promise.resolve(this.platform.getb2bAPIs()).then(response => {
        this.apiResponseFromServerForB2B = this.platform.b2bExecutors;
        this.apiResponseFromServerForMyProviders = this.platform.myProviderExecutors;
        this.providerObjects = this.platform.providerObjects;
      }, error => {
        this.platform.openSnackBar('Error while fetching your subscribed service providers. Please try again after sometime', 'Error', {
          duration: 10000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    }
  }

  public getMyConnectors = async () =>  {
    if (this.platform.registeredConnectors !== null && this.platform.registeredConnectors !== undefined) {
      this.registeredConnectors = this.platform.registeredConnectors;
      this.registeredConnectors.forEach(registeredConnector => {
        if (registeredConnector['connectors']) {
          const connectorList = registeredConnector['connectors'];
          if (connectorList) {
            connectorList.forEach(connector => {
              this.apiConnectorList.push([registeredConnector.producer + '_' + connector.authType + '_' + connector.name, registeredConnector.producer + '_' + connector.authType + '_' + connector.name]);
            });
          }
          return this.registeredConnectors;
        }
      });
    } else {
      await this.cfgSrv.getData('services', 'services', 'v1','apiconnectors', 'partner=' + this.partner + '&account=' + this.account_id)
          .toPromise().then(data => {
            this.registeredConnectors = data;
            this.platform.registeredConnectors = data;
            this.registeredConnectors.forEach(registeredConnector => {
              if (registeredConnector['connectors']) {
                const connectorList = registeredConnector['connectors'];
                if (connectorList) {
                  connectorList.forEach(connector => {
                    this.apiConnectorList.push([registeredConnector.producer + '_' + connector.authType + '_' + connector.name, registeredConnector.producer + '_' + connector.authType + '_' + connector.name]);
                  });
                }
                return this.registeredConnectors;
              }
            });
          });
    }

  }

  public getMyAPIs = async () =>  {
    if (this.platform.partnerExecutors !== null && this.platform.partnerExecutors !== undefined) {
      this.items = this.platform.partnerExecutors;
      return this.items;
    } else {
      await this.cfgSrv.getApiExecutorsForPartnerAccount(this.partner, this.account_id)
          .toPromise().then(data => {
            this.items = data;
            this.platform.partnerExecutors = data;
            return data;
          });
    }
  }

  async copyTo() {
    if (this.orig_executor && this.orig_executor !== null && this.orig_executor !== undefined) {
      const metaSchema = JSON.parse(JSON.stringify(this.orig_executor));
      this.platform.copyToPartner(this.orig_executor['executor_name'], this.orig_executor['executor_version'], 'BUSINESSLOGIC', metaSchema);
    }
  }

  async ngAfterViewInit(): Promise<void> {
    const that = this;
    await this.getb2bAPIs();
    await this.getMyAPIs();
    this.apiConnectorList.push(['Select API Connector ', 'null']);
    await this.getMyConnectors();

    this.blocklyXMLToolbox = '<xml style="display: none;">' +
        '<category name="Core Logic Builder" colour="210">\n' +
        '        <category name="Logic" >\n' +
        '            <block type="controls_if"></block>\n' +
        '            <block type="logic_compare"></block>\n' +
        '            <block type="logic_operation"></block>\n' +
        '            <block type="logic_negate"></block>\n' +
        '            <block type="logic_boolean"></block>\n' +
        '            <block type="logic_null"></block>\n' +
        '            <block type="logic_ternary"></block>\n' +
        '        </category>\n' +
        '        <category name="Lists">\n' +
        '            <block type="lists_create_empty"></block>\n' +
        '            <block type="lists_create_with"></block>\n' +
        '            <block type="lists_repeat">\n' +
        '                <value name="NUM">\n' +
        '                    <block type="math_number">\n' +
        '                        <field name="NUM">5</field>\n' +
        '                    </block>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="lists_length"></block>\n' +
        '            <block type="lists_isEmpty"></block>\n' +
        '            <block type="lists_indexOf"></block>\n' +
        '            <block type="lists_getIndex"></block>\n' +
        '            <block type="lists_setIndex"></block>\n' +
        '            <block type="lists_append"></block>\n' +
        '            <block type="lists_splice"></block>\n' +
        '            <block type="lists_contains"></block>\n' +
        '        </category>\n' +
        '        <category name="JSON">\n' +
        '            <block type="json_object"></block>\n' +
        '            <block type="key_value_pair"></block>\n' +
        '            <block type="get_keys_from_json_object"></block>\n' +
        '            <block type="get_a_key_from_json_object"></block>\n' +
        '            <block type="replace_key_in_json"></block>\n' +
        '            <block type="insert_key_value_pair_in_json"></block>\n' +
        '            <block type="remove_key_from_json"></block>\n' +
        '            <block type="parse_json"></block>\n' +
        '        </category>\n' +
        '        <category name="Text" >\n' +
        '            <block type="text"></block>\n' +
        '            <block type="text_join"></block>\n' +
        '            <block type="text_substring_count"></block>\n' +
        '            <block type="text_get_ascii_code"></block>\n' +
        '            <block type="text_append">\n' +
        '                <value name="TEXT">\n' +
        '                    <shadow type="text"></shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="text_length">\n' +
        '                <value name="VALUE">\n' +
        '                    <shadow type="text">\n' +
        '                        <field name="TEXT">abc</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="text_isEmpty">\n' +
        '                <value name="VALUE">\n' +
        '                    <shadow type="text">\n' +
        '                        <field name="TEXT"></field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="text_indexOf">\n' +
        '                <value name="VALUE">\n' +
        '                    <block type="variables_get">\n' +
        '                        <field name="VAR">abc</field>\n' +
        '                    </block>\n' +
        '                </value>\n' +
        '                <value name="FIND">\n' +
        '                    <shadow type="text">\n' +
        '                        <field name="TEXT">abc</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="text_charAt">\n' +
        '                <value name="VALUE">\n' +
        '                    <block type="variables_get">\n' +
        '                        <field name="VAR">abc</field>\n' +
        '                    </block>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="text_getSubstring">\n' +
        '                <value name="STRING">\n' +
        '                    <block type="variables_get">\n' +
        '                        <field name="VAR">abc</field>\n' +
        '                    </block>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="text_changeCase">\n' +
        '                <value name="TEXT">\n' +
        '                    <shadow type="text">\n' +
        '                        <field name="TEXT">abc</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="text_trim">\n' +
        '                <value name="TEXT">\n' +
        '                    <shadow type="text">\n' +
        '                        <field name="TEXT">abc</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="text_replace">\n' +
        '                <value name="TEXT">\n' +
        '                     </value>\n' +
        '                </block>\n' +
        '            <block type="text_split">\n' +
        '                <value name="TEXT">\n' +
        '                     </value>\n' +
        '                </block>\n' +
        '            <block type="text_print">\n' +
        '                <value name="TEXT">\n' +
        '                    <shadow type="text">\n' +
        '                        <field name="TEXT">abc</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="text_decode_base64"></block>\n' +
        '            <block type="text_decode_zip_content_bytes"></block>\n' +
        // '            <block type="text_prompt_ext">\n' +
        // '                <value name="TEXT">\n' +
        // '                    <shadow type="text">\n' +
        // '                        <field name="TEXT">abc</field>\n' +
        // '                    </shadow>\n' +
        // '                </value>\n' +
        // '            </block>\n' +
        '        </category>\n' +
        '        <category name="Parse" >\n' +
        '            <block type="parse_boolean"></block>\n' +
        '            <block type="parse_byte"></block>\n' +
        '            <block type="parse_character"></block>\n' +
        '            <block type="parse_date"></block>\n' +
        '            <block type="parse_double"></block>\n' +
        '            <block type="parse_float"></block>\n' +
        '            <block type="parse_int"></block>\n' +
        '            <block type="parse_long"></block>\n' +
        '            <block type="parse_short"></block>\n' +
        '            <block type="parse_string"></block>\n' +
        '            <block type="parse_timestamp"></block>\n' +
        '            <block type="parse_datatype"></block>\n' +
        '        </category>\n' +
        '        <category name="Loops" >\n' +
        '            <block type="controls_repeat_ext">\n' +
        '                <value name="TIMES">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">10</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="controls_whileUntil"></block>\n' +
        '            <block type="controls_for">\n' +
        '                <value name="FROM">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">1</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '                <value name="TO">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">10</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '                <value name="BY">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">1</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="controls_forEach"></block>\n' +
        '            <block type="controls_flow_statements"></block>\n' +
        '        </category>\n' +
        '        <category name="Math">\n' +
        '            <block type="math_number"></block>\n' +
        '            <block type="math_arithmetic">\n' +
        '                <value name="A">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">1</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '                <value name="B">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">1</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="math_single">\n' +
        '                <value name="NUM">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">9</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="math_trig">\n' +
        '                <value name="NUM">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">45</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="math_constant"></block>\n' +
        '            <block type="math_number_property">\n' +
        '                <value name="NUMBER_TO_CHECK">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">0</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="math_round">\n' +
        '                <value name="NUM">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">3.1</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="math_on_list"></block>\n' +
        '            <block type="math_modulo">\n' +
        '                <value name="DIVIDEND">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">64</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '                <value name="DIVISOR">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">10</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="math_constrain">\n' +
        '                <value name="VALUE">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">50</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '                <value name="LOW">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">1</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '                <value name="HIGH">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">100</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="math_random_int">\n' +
        '                <value name="FROM">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">1</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '                <value name="TO">\n' +
        '                    <shadow type="math_number">\n' +
        '                        <field name="NUM">100</field>\n' +
        '                    </shadow>\n' +
        '                </value>\n' +
        '            </block>\n' +
        '            <block type="math_random_float"></block>\n' +
        '        </category>\n' +
        '        <category name="Files" >\n' +
        // '            <block type="connect_workbook"></block>\n' +
        // '            <block type="read_worksheet_cell"></block>\n' +
        // '            <block type="write_cell_to_worksheet"></block>\n' +
        // '            <block type="worksheet_url"></block>\n' +
        '            <block type="read_csv"></block>\n' +
        // '            <block type="write_csv"></block>\n' +
        '            <block type="write_csv_block"></block>\n' +
        '            <block type="read_csv_generic"></block>\n' +
        '            <block type="write_csv_generic"></block>\n' +
        '            <block type="read_file_input_bytes"></block>\n' +
        '        </category>\n' +
        '        <category name="Date and Time">\n' +
        '            <block type="current_timestamp"></block>\n' +
        '            <block type="current_date"></block>\n' +
        '            <block type="current_date_with_format"></block>\n' +
        '            <block type="current_date_time"></block>\n' +
        '            <block type="current_date_time_with_format"></block>\n' +
        '            <block type="date_arithmetic"></block>\n' +
        '            <block type="get_date_attribute"></block>\n' +
        '            <block type="parse_date_from_string_with_format"></block>\n' +
        '            <block type="format_date_with_string_formatter"></block>\n' +
        '            <block type="parse_date_from_string"></block>\n' +
        '        </category>\n' +
        '        <category name="Variables" custom="VARIABLE"></category>\n' +
        // '        <category name="Functions" custom="PROCEDURE"></category>\n' +
        '</category>\n' +
        '    <category name="API Builder" colour="230">' +
        '       <category name="API Authorization">';
    if (this.authorizationBlocks){
      this.authorizationBlocks.forEach(authBlock => {
        this.blocklyXMLToolbox = this.blocklyXMLToolbox + '           <block type="' + authBlock.name + '"></block>\n';
      });
    }
    this.blocklyXMLToolbox = this.blocklyXMLToolbox + '       </category>\n' +
        '        <category name="API Execution">\n' +
        '            <block type="execute_api"></block>\n' +
        '            <block type="pass_parameters_to_api_executor"></block>\n' +
        '            <block type="parallel_execution"></block>\n' +
        '            <block type="parallel_execution_with_foreach_no_wait"></block>\n' +
        '            <block type="parallel_execution_with_foreach_wait_until"></block>\n' +
        '        </category>\n' +
        '       <category name="API Return" custom="APIRESPONSE"></category>\n' +
        '    <category name="API Attributes" custom="ATTRIBUTE_PALETTE"></category>\n' +
        '    <category name="API Connectors" custom="API_CONNECTORS"></category>\n' +
        '    <category name="Add Authorization To" custom="ADDTO_PALETTE"></category>\n' +
        '    </category>\n' +
        '    <category name="SQL Operations" custom="SQLOPERATIONS"></category>\n'


    if (this.items && this.items !== null && this.items !== undefined && this.items.length > 0) {
      this.blocklyXMLToolbox += '<category name="My APIs" colour="300">';


      this.items.forEach((item) => {
        if (item && item['executors'] && item['executors'] !== null && item['executors'] !== undefined) {
          item.executors.forEach((executor) => {
            if (executor && executor !== null && executor !== undefined && executor['executor_category'] && executor['executor_version'] && executor['executor_category'] !== null && executor['executor_category'] !== undefined && executor['executor_version'] !== null && executor['executor_version'] !== undefined) {
              const apiName = executor['executor_category'] + '_' + executor['executor_version'];
              if ( this.entityName.includes(apiName) === false) {
                this.entityName.push(apiName);
              }
            }
          });
        }
      });

      if (this.entityName && this.entityName !== undefined && this.entityName !== null) {
        this.entityName.forEach((entity) => {
          if (entity && entity !== undefined && entity !== null) {
            this.blocklyXMLToolbox = this.blocklyXMLToolbox + '<category name="' + entity + '">';
            this.blocklyXMLToolbox = this.blocklyXMLToolbox + this.loadExecutorBlockBasedOnEntity(entity);
            this.blocklyXMLToolbox = this.blocklyXMLToolbox + '</category>';
          }
        });

        this.blocklyXMLToolbox = this.blocklyXMLToolbox + '</category>';
      }
    }

    if (this.apiResponseFromServerForB2B && this.apiResponseFromServerForB2B !== undefined && this.apiResponseFromServerForB2B !== null) {
      this.blocklyXMLToolbox += '<category name="My Subscriptions" colour="300">';
      this.apiResponseFromServerForB2B.forEach((b2b) => {
        if (b2b && b2b.serviceProvider && b2b.serviceProvider !== null && b2b.serviceProvider !== undefined && b2b.serviceProvider !== '') {
          this.blocklyXMLToolbox += '<category name="' + this.getServiceProviderDisplayName(b2b.serviceProvider) + '" colour="350">';
          b2b.categories.forEach((category) => {
            if (category && category.category && category.category !== null && category.category !== undefined) {
              this.blocklyXMLToolbox += '<category name="' + category.category + '">';
              category.executors.forEach((executor) => {
                if (executor && executor.executor_category && executor.executor_category_group && executor.executor_category_group !== null && executor.executor_category_group !== undefined && executor.executor_category_group !== '' && executor.executor_category !== null && executor.executor_category !== undefined && executor.executor_category !== '') {
                  const temp = executor.executor_category_group + '>' + executor.executor_category;
                  this.blocklyXMLToolbox += this.loadb2bExecutorBlockBasedOnEntity(temp, executor, category);
                }
              });
              this.blocklyXMLToolbox += '</category>';
            }
          });
          this.blocklyXMLToolbox += '</category>';
        }
      });
      this.blocklyXMLToolbox += '</category>';
    }

    if (this.apiResponseFromServerForMyProviders && this.apiResponseFromServerForMyProviders !== undefined && this.apiResponseFromServerForMyProviders !== null) {
      this.blocklyXMLToolbox += '<category name="My Service Providers" colour="300">';
      this.apiResponseFromServerForMyProviders.forEach((myProvider) => {
        if (myProvider && myProvider.serviceProvider && myProvider.serviceProvider !== null && myProvider.serviceProvider !== undefined && myProvider.serviceProvider !== '') {
          this.blocklyXMLToolbox += '<category name="' + this.getServiceProviderDisplayName(myProvider.serviceProvider) + '" colour="350">';
          myProvider.categories.forEach((category) => {
            if (category && category.category && category.category !== null && category.category !== undefined) {
              this.blocklyXMLToolbox += '<category name="' + category.category + '">';
              category.executors.forEach((executor) => {
                if (executor && executor.executor_category && executor.executor_category_group && executor.executor_category_group !== null && executor.executor_category_group !== undefined && executor.executor_category_group !== '' && executor.executor_category !== null && executor.executor_category !== undefined && executor.executor_category !== '') {
                  const temp = executor.executor_category_group + '>' + executor.executor_category;
                  this.blocklyXMLToolbox += this.loadb2bExecutorBlockBasedOnEntity(temp, executor, category);
                } else {
                  executor.executor_category_group = 'temp';
                  const temp = executor.executor_category_group + '>' + executor.executor_category;
                  this.blocklyXMLToolbox += this.loadb2bExecutorBlockBasedOnEntity(temp, executor, category);
                }
              });
              this.blocklyXMLToolbox += '</category>';
            }
          });
          this.blocklyXMLToolbox += '</category>';
        }
      });
      this.blocklyXMLToolbox += '</category>';
    }

    this.blocklyXMLToolbox = this.blocklyXMLToolbox + '</xml>';
    // if (this.router.url.includes('/businesslogic')) {
    this.workspace = Blockly.inject(this.workSpaceId, {toolbox: this.blocklyXMLToolbox});
    // const parser = new DOMParser();
    // this.blocklyXMLToolbox = parser.parseFromString(this.blocklyXMLToolbox,'text/xml');
    // this.workspace = Blockly.inject('blocklyDiv',
    //     {toolbox: this.toolbox.nativeElement});
    this.workspace.registerToolboxCategoryCallback(
        'ATTRIBUTE_PALETTE', this.attributes);
    this.workspace.registerToolboxCategoryCallback(
        'ADDTO_PALETTE', this.addTo);
    this.workspace.registerToolboxCategoryCallback(
        'API_CONNECTORS', this.apiConnectors);
    this.workspace.registerToolboxCategoryCallback(
        'APIRESPONSE', this.apiResponse);
    this.workspace.registerToolboxCategoryCallback(
        'SQLOPERATIONS', this.sqlOperations);

    // this.getExecutors();
    this.loadExecutor();
    this.loading = true;
    this.blocklyRendered.emit(true);
    // }
  }

  capitalize(str) {
    const val = str;
    const substr = val.split(' ');
    const returnVal = [];

    substr.forEach((value) => {
      if (value) {
        returnVal.push(value.charAt(0).toUpperCase() + value.slice(1));
      }
    });
    return returnVal.join(' ');
  }

  getServiceProviderDisplayName(str) {
    if (this.providerObjects && this.providerObjects.hasOwnProperty(str) && this.providerObjects[str] !== '') {
      return this.providerObjects[str];
    } else {
      return this.capitalize(str);
    }
  }

  copyMessage(event) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = $(event.target).text();
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  loadAuthorization() {
    if (this.authorizationBlocks) {
      this.authorizationBlocks.forEach(block => {
        Blockly.Blocks[block.name] = {
          init: function() {
            this.appendDummyInput()
                .appendField(block.displayName);
            if (block.authAttributes){
              block.authAttributes.forEach(attribute => {
                this.appendValueInput(attribute.key)
                    .setCheck(null)
                    .appendField(attribute.displayName);
              });
            }
            this.setOutput(true, null);
            this.setColour(230);
            this.setTooltip('');
            this.setHelpUrl('');
          }
        };

      });
    }
  }

  constructExecutor() {
    const that = this;
    return new Promise((resolve, reject) => {
      if (this.cloneable === false && this.isFromHistory === false) {
        //this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(data => {
        if (that.orig_executor != null) {
          that.selectedExecutorType = that.orig_executor['executor_type'];
          that.executor_name = that.orig_executor['executor_name'];
          that.selectedVersion = that.orig_executor['executor_version'];
          that.executor_display_name = that.orig_executor['executor_display_name'];
          that.description = that.orig_executor['executor_description'];
          that.executorCategory = that.orig_executor['executor_category'];
          that.scopeSelected = that.orig_executor.scopeOfAccess ? that.orig_executor.scopeOfAccess : that.orig_executor.executor_scope;;
          that.selectedExecutor = that.orig_executor['executor_method_type'];
          that.queryParams = that.orig_executor['queryParams'];
          that.headers = that.orig_executor['headers'];
          that.authModel = that.orig_executor['authModel'];
          that.requestBody = that.orig_executor['requestBody'];
          that.prerequisites = that.orig_executor['prerequisites'];
          that.xml_content = that.orig_executor['source'];
          that.attributeList = that.orig_executor['block_attributes'];

          resolve('success');
        }
        // }, error => {
        //   reject('failed');
        // });
      } else if (this.isFromHistory === true && this.cloneable === false) {
        if (this.historyData && this.historyData !== undefined && this.historyData !== null) {
          that.selectedExecutorType = this.historyData['executor_type'];
          that.executor_name = this.historyData['executor_name'];
          that.selectedVersion = this.historyData['executor_version'];
          that.executor_display_name = this.historyData['executor_display_name'];
          that.description = this.historyData['executor_description'];
          that.executorCategory = this.historyData['executor_category'];
          that.scopeSelected = this.historyData['scopeOfAccess'];
          that.selectedExecutor = this.historyData['executor_method_type'];
          that.queryParams = this.historyData['queryParams'];
          that.headers = this.historyData['headers'];
          that.authModel = this.historyData['authModel'];
          that.requestBody = this.historyData['requestBody'];
          that.prerequisites = this.historyData['prerequisites'];
          that.xml_content = this.historyData['source'];
          that.attributeList = this.historyData['block_attributes'];
          resolve('success');
        } else {
          resolve('success');
        }
      } else {
        that.selectedExecutorType = this.platform.cloneableData['executor_type'];
        that.executor_name = this.platform.cloneableData['executor_name'];
        that.selectedVersion = this.platform.cloneableData['executor_version'];
        that.executor_display_name = this.platform.cloneableData['executor_display_name'];
        that.description = this.platform.cloneableData['executor_description'];
        that.executorCategory = this.platform.cloneableData['executor_category'];
        that.scopeSelected = this.platform.cloneableData['scopeOfAccess'];
        that.selectedExecutor = this.platform.cloneableData['executor_method_type'];
        that.queryParams = this.platform.cloneableData['queryParams'];
        that.headers = this.platform.cloneableData['headers'];
        that.authModel = this.platform.cloneableData['authModel'];
        that.requestBody = this.platform.cloneableData['requestBody'];
        that.prerequisites = this.platform.cloneableData['prerequisites'];
        that.xml_content = this.platform.cloneableData['source'];
        that.attributeList = this.platform.cloneableData['block_attributes'];
        resolve('success');
      }
    });
  }

  loadExecutor() {
    const that = this;
    this.loadResponse();
    this.loadParallel();
    this.loadSqlOperations();
    this.loadJsonObjects();
    this.loadAttributes();
    this.loadApiConnectors();
    this.loadAddToAttributes();
    this.loadAuthorization();
    // this.loadExecutorBlocks();

    // let partnerEdited = this.partner;
    // let accountEdited = this.account;
    // let entityEdited = this.entity;
    // let versionEdited = this.version;
    // if (this.cloneable) {
    //     partnerEdited = this.platform.cloneableData.partner;
    //     accountEdited = this.platform.cloneableData.account;
    //     entityEdited = this.platform.cloneableData.executor_name;
    //     versionEdited = this.platform.cloneableData.executor_version;
    // }
    if (this.entity !== null && this.entity !== undefined &&
        this.version !== null && this.version !== undefined) {
      if (this.businessLogicEdit === true) {
        //Promise.resolve(this.getAPIExecutor()).then(response => {
        if (this.orig_executor && this.orig_executor !== null && this.orig_executor !== undefined) {
          this.constructExecutorAndContinue();
        } else {
          this.platform.openSnackBar('Error while retrieving business logic API. Please try again after sometime ', 'Error', {
            duration: 10000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
        //});
      } else {
        this.constructExecutorAndContinue();
      }
    } else {
      if (this.isFromHistory === true && this.cloneable === false) {
        Promise.resolve(this.getHistory(this.partner, this.account_id, this.historyTimestamp)).then(response => {
          if (this.entity !== null && this.entity !== undefined &&
              this.version !== null && this.version !== undefined) {
            this.constructExecutorAndContinue();
          } else {
            this.platform.openSnackBar('Error while retrieving business logic API. Please try again after sometime ', 'Error', {
              duration: 10000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          }
        });
      }
    }
  }

  constructExecutorAndContinue() {
    const that = this;
    Promise.resolve(this.constructExecutor()).then(response => {
      if(this.xml_content != null){
        var blockText = this.xml_content;
        const parser = new DOMParser();
        const xml1 = parser.parseFromString(this.xml_content, 'text/xml');
        var xmlNode = xml1.getElementsByTagName('xml');
        if(xmlNode) {
          for (var i = 0; i < xmlNode.length; i++) {
            for (var j = 0; j < xmlNode[i].childNodes.length; j++) {
              var el = xmlNode[i].childNodes[j];
              if (el.childNodes.length !== 1) {
                blockText = '<xml xmlns="http://www.w3.org/1999/xhtml">' + Blockly.Xml.domToText(el) +'</xml>';
              }
            }
          }
        } else {
          blockText = '<xml xmlns="http://www.w3.org/1999/xhtml">' + this.xml_content +'</xml>';

        }
      }
      if (blockText) {
        try {
          var xml1 = Blockly.Xml.textToDom(blockText);
          Blockly.Xml.domToWorkspace(xml1, that.workspace);
        } catch (error) {
          this.platform.openSnackBar('Error while loading business logic API: ' + error, 'Error', {
            duration: 10000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }

      }
    }, error => {
      this.platform.openSnackBar('Error while loading business logic API: ' + error, 'Error', {
        duration: 10000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  getExecutorList(data) {
    for (let cat of data) {
      for(let exe of cat.executors) {
        this.executorList.push(cat.category + '-' + exe.executor_name);
      }
    }
  }
  ngOnChanges() {
    this.appComp.currentPageTitle = 'Create Business Logic API';
    this._route.queryParams
        .subscribe(async params => {
          if (params) {
            if (params.clone && params.clone === 'true') {
              this.cloneable = true;
              if (this.platform.cloneableData !== undefined) {
                this.entity = this.platform.cloneableData['executor_name'];
                this.version = this.platform.cloneableData['executor_version'];
                this.orig_executor_name = this.platform.cloneableData['executor_name'];
                this.orig_executor_version = this.platform.cloneableData['executor_version'];
                this.editFlag = false;
              } else {
                this.editFlag = false;
                this.router.navigateByUrl('/businesslogic');
              }
            } else if (params.entity && params.version) {
              this.entity = params.entity;
              this.version = params.version;
              this.orig_executor_name = params.entity;
              this.orig_executor_version = params.version;
              this.editFlag = true;
            } else {
              this.editFlag = false;
            }
            const that = this;
            // this.attributeList.push(['Select Target Attributes', 'null'],
            //     ['API.name', 'API.name'],
            //     ['API.version', 'API.version'],
            //     ['API.methodType', 'API.methodType'],
            //     ['API.type', 'API.type'],
            //     ['Headers', 'Headers'],
            //     ['Parameters', 'Parameters'],
            //     ['Authorization', 'Authorization']);

            if(this.attributeList){
              if (this.attributeList.findIndex(p => p[0] === 'Select Target Attributes') === -1) {
                this.attributeList.push(['Select Target Attributes', 'null']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'API.name') === -1) {
                this.attributeList.push(['API.name', 'API.name']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'API.version') === -1) {
                this.attributeList.push(['API.version', 'API.version']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'API.methodType') === -1) {
                this.attributeList.push(['API.methodType', 'API.methodType']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'API.type') === -1) {
                this.attributeList.push(['API.type', 'API.type']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'Headers') === -1) {
                this.attributeList.push(['Headers', 'Headers']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'Parameters') === -1) {
                this.attributeList.push(['Parameters', 'Parameters']);
              }
              if (this.attributeList.findIndex(p => p[0] === 'Authorization') === -1) {
                this.attributeList.push(['Authorization', 'Authorization']);
              }
            }


            this.addToList.push(['Headers', 'Headers'], ['Parameters', 'Parameters']);
            this.attributes = function() {
              return that.loadAttributes();
            };
            this.apiConnectors = function() {
              return that.loadApiConnectors();
            };
            this.addTo = function() {
              return that.loadAddToAttributes();
            };
            this.apiResponse = function() {
              return that.loadResponse();
            };
            this.sqlOperations = function() {
              return that.loadSqlOperations();
            };
            this.parallel = function() {
              return that.loadParallel();
            };
            // const that = this;
            const textWorkspace = new Blockly.Workspace();

            // this.executors = function() {
            //     return that.loadExecutorBlocks();
            // };
            // this.gatewayUrl = (this.partner === this.account ? 'gateway.' + this.partner + '.apiplatform.io' : 'gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
            this.gatewayUrl = await this.platform.getDefaultGatewayURL();
            this.gatewayFullUrl = 'https://' + this.gatewayUrl;

            this._service.getItems('v1', 'services', 'services', 'authorizationTypes', false).subscribe(authTypes => {
              this.authorizationBlocks = authTypes;
            });
          } else {
            this.editFlag = false;
          }
        });
  }
  async ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    this.appComp.currentPageTitle = 'Create Business Logic API';
    if (this.platform.partnerEntities !== null && this.platform.partnerEntities !== undefined) {
      this.partnerEntities = this.platform.partnerEntities;
    } else {
      this.cfgSrv.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data1 => {
        if (data1 && data1 !== undefined && data1 !== null) {
          this.partnerEntities = data1;
          this.platform.partnerEntities = this.partnerEntities;
        } else {
          this.platform.openSnackBar('Error while retrieving data access entities for your account', 'Error', {
            duration: 30000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }, error => {
        this.platform.openSnackBar('Error while retrieving data access entities for your account', 'Error', {
          duration: 30000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    }

    if (this.platform.leftpanelData !== null && this.platform.leftpanelData !== undefined) {
      this.partnerExecutors = this.platform.leftpanelData;
    } else {
      this.cfgSrv.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {
        if (data && data !== null && data !== undefined) {
          this.partnerExecutors = data;
          // this.platform.leftpanelData = data;
        } else {
          this.platform.openSnackBar('Error while retrieving API executors for your account', 'Error', {
            duration: 30000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }, error => {
        this.platform.openSnackBar('Error while retrieving API executors for your account', 'Error', {
          duration: 30000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    }
    if (this.platform.databases !== null && this.platform.databases !== undefined) {
      await this.platform.updateIsNoSQLForMongo(this.platform.databases);
      this.databases = this.platform.databases;
    } else {
      // this.platform.getDatabasesForPartnerAccount();
      await this.cfgSrv.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
            await this.platform.updateIsNoSQLForMongo(databases);
            this.databases = this.platform.databases;
          },
          error => {
            this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
          });
      this.databases = this.platform.databases;
    }
    if (this.databases) {
      if (this.databases.databaseDetails && this.databases.databaseDetails !== null && this.databases.databaseDetails !== undefined) {
        this.databases.databaseDetails.forEach(database => {
          if (!database.is_nosql) {
            this.sqlDatabases.push([database.database_name, database.database_name]);
          }
        });
      }
    }
  }

  updateAttributes() {
    this.requestBody = this.devexHeader.getRequestBody();
    if (this.requestBody.hasOwnProperty('__zone_symbol__value')) {
      this.requestBody = this.requestBody['__zone_symbol__value'];
    }
    const that = this;
    // this.attributeList = [];
    // this.attributeList[0] = ['Select Target Attributes', 'null'];
    if(this.attributeList){
      this.attributeList.forEach((attr, index) => {
        if (attr[0].includes('Parameter') || attr[0].includes('Header') || attr[0].includes('Payload')) {
          that.attributeList.splice(index, 1);
        }
      });
      if (this.attributeList.findIndex(p => p[0] === 'API.name') === -1) {
        this.attributeList.push(['API.name', 'API.name']);
      }
      if (this.attributeList.findIndex(p => p[0] === 'API.version') === -1) {
        this.attributeList.push(['API.version', 'API.version']);
      }
      if (this.attributeList.findIndex(p => p[0] === 'API.methodType') === -1) {
        this.attributeList.push(['API.methodType', 'API.methodType']);
      }
      if (this.attributeList.findIndex(p => p[0] === 'API.type') === -1) {
        this.attributeList.push(['API.type', 'API.type']);
      }
      if (this.attributeList.findIndex(p => p[0] === 'Headers') === -1) {
        this.attributeList.push(['Headers', 'Headers']);
      }
      if (this.attributeList.findIndex(p => p[0] === 'Parameters') === -1) {
        this.attributeList.push(['Parameters', 'Parameters']);
      }
    }


    this.headers.forEach((queryParam) => {
      if(queryParam && queryParam.key!= "") {
        if (that.attributeList.findIndex(p => p[0] === 'Header.' + queryParam.key) === -1) {
          that.attributeList.push(['Header.' + queryParam.key, 'Header.' + queryParam.key]);
        }
      }
    });
    this.queryParams.forEach((queryParam) => {
      if(queryParam && queryParam.key!= "") {
        if (that.attributeList.findIndex(p => p[0] === 'Parameter.' + queryParam.key) === -1) {
          that.attributeList.push(['Parameter.' + queryParam.key, 'Parameter.' + queryParam.key]);
        }
      }
    });
    if (this.devexHeader.requestBodySelected !== 'raw') {
      if (this.requestBody && this.requestBody['value'].length > 0) {
        this.requestBody['value'].forEach((queryParam) => {
          if(queryParam && queryParam.key!= "") {
            if (that.attributeList.findIndex(p => p[0] === 'Payload.' + queryParam.key) === -1) {
              that.attributeList.push(['Payload.' + queryParam.key, 'Payload.' + queryParam.key]);
            }
          }
        });
        // this.requestBody = {};
      }
    } else {
      if (this.requestBody && this.requestBody['value'] !== '') {
        if (this.attributeList.findIndex(p => p[0] === 'Payload') === -1) {
          this.attributeList.push(['Payload', 'Payload']);
        }
        // this.requestBody = {};
      }
    }
    this.platform.openSnackBar('Header and Parameter Updated successfully', 'Success', {
       duration: 5000,
       verticalPosition: 'top',
       horizontalPosition: 'center'
    });
  }
  loadAttributes(){
    const that = this;
    Blockly.Blocks['attributes'] = {
      init: function() {
        this.setColour(80);
        this.setOutput(true);
        this.appendDummyInput()
            .appendField(new Blockly.FieldDropdown(that.attributeList), 'MODE');
      },
      onchange: function(event) {
      }
    };
    var xmlList = [];
    var blockText = '<xml><block type="attributes"></block></xml>';
    var block = Blockly.Xml.textToDom(blockText).firstChild;
    xmlList.push(block);
    return xmlList;
  }

  loadApiConnectors() {
    const that = this;
    Blockly.Blocks['api_connector'] = {
      init: function() {
        this.setColour(110);
        this.setOutput(true);
        this.appendDummyInput()
            .appendField(new Blockly.FieldDropdown(that.apiConnectorList), 'MODE');
      },
      onchange: function(event) {
      }
    };
    var xmlList = [];
    var blockText = '<xml><block type="api_connector"></block></xml>';
    var block = Blockly.Xml.textToDom(blockText).firstChild;
    xmlList.push(block);
    return xmlList;
  }

  loadAddToAttributes(){
    const that = this;
    Blockly.Blocks['addTo'] = {
      init: function() {
        this.setColour(80);
        this.setOutput(true);
        this.appendDummyInput()
            .appendField(new Blockly.FieldDropdown(that.addToList), 'MODE');
      },
      onchange: function(event) {
      }
    };
    var xmlList = [];
    var blockText = '<xml><block type="addTo"></block></xml>';
    var block = Blockly.Xml.textToDom(blockText).firstChild;
    xmlList.push(block);
    return xmlList;
  }

  loadSqlOperations() {

    if (this.sqlDatabases && this.sqlDatabases.length > 0) {
      Blockly.defineBlocksWithJsonArray([
        {
          "type": "sql_transactions",
          "message0": "database transactions on %1",
          "args0": [
            {
              "type": "field_dropdown",
              "name": "MODE",
              "options": this.sqlDatabases
            }
          ],
          "message1": "DO %1",
          "args1": [{
            "type": "input_statement",
            "name": "DO"
          }],
          "previousStatement": null,
          "nextStatement": null,
          "style": "loop_blocks",
          "helpUrl": "%{BKY_CONTROLS_WHILEUNTIL_HELPURL}",
          "extensions": ["controls_whileUntil_tooltip"]
        }
      ]);

      var xmlList = [];
      var blockText = '<xml><block type="sql_transactions"></block></xml>';
      var block = Blockly.Xml.textToDom(blockText).firstChild;
      xmlList.push(block);

      Blockly.Blocks['sql_commit'] = {
        init: function () {
          this.setColour(100);
          this.setNextStatement(true);
          this.setPreviousStatement(true);
          this.appendDummyInput().appendField('commit');
        },
        onchange: function(event) {
        }
      };

      var blockText = '<xml><block type="sql_commit"></block></xml>';
      var block = Blockly.Xml.textToDom(blockText).firstChild;
      xmlList.push(block);

      Blockly.Blocks['sql_rollback'] = {
        init: function () {
          this.setColour(100);
          this.setNextStatement(true);
          this.setPreviousStatement(true);
          this.appendDummyInput().appendField('rollback');
        },
        onchange: function(event) {
        }
      };
      var blockText = '<xml><block type="sql_rollback"></block></xml>';
      var block = Blockly.Xml.textToDom(blockText).firstChild;
      xmlList.push(block);

      // Blockly.Blocks['sql_batch'] = {
      //     init: function () {
      //         this.setColour(100);
      //         this.setNextStatement(true);
      //         this.setPreviousStatement(true);
      //         this.appendValueInput('VALUE').appendField('batch operation on database');
      //     },
      //     onchange: function(event) {
      //     }
      // };
      // var blockText = '<xml><block type="sql_batch"></block></xml>';
      // var block = Blockly.Xml.textToDom(blockText).firstChild;
      // xmlList.push(block);


      return xmlList;
    } else {
      return [];
    }
  }

  loadResponse(){
    Blockly.Blocks['api_response'] = {
      init: function () {
        this.setColour(100);
        // this.setNextStatement(true);
        this.setPreviousStatement(true);
        this.appendValueInput('VALUE').appendField('return');
      },
      onchange: function(event) {
      }
    };
    var xmlList = [];
    var blockText = '<xml><block type="api_response"></block></xml>';
    var block = Blockly.Xml.textToDom(blockText).firstChild;
    xmlList.push(block);

    Blockly.Blocks['api_response_error'] = {
      init: function () {
        this.setColour(100);
        this.setPreviousStatement(true);
        this.appendDummyInput()
            .appendField('return custom error');
        this.appendValueInput('errorCode')
            .setCheck(null)
            .appendField('Error Code');
        this.appendValueInput('errorMessage')
            .setCheck(null)
            .appendField('Error Message');
        // this.setOutput(true, null);
        this.setTooltip('');
        this.setHelpUrl('');
      },
      onchange: function(event) {
      }
    };
    var blockText = '<xml><block type="api_response_error"></block></xml>';
    var block = Blockly.Xml.textToDom(blockText).firstChild;
    xmlList.push(block);

    Blockly.Blocks['api_response_custom'] = {
      init: function() {
        this.setPreviousStatement(true);
        this.appendDummyInput()
            .appendField('return custom response');
        this.appendValueInput('statusCode')
            .setCheck(null)
            .appendField('Status Code');
        this.appendValueInput('responseBody')
            .setCheck(null)
            .appendField('Response Body');
        this.appendValueInput('headers')
            .setCheck(null)
            .appendField('Headers');
        // this.setOutput(true, null);
        this.setColour(100);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };
    var blockText = '<xml><block type="api_response_custom"></block></xml>';
    var block = Blockly.Xml.textToDom(blockText).firstChild;
    xmlList.push(block);
    return xmlList;
  }

  loadParallel(){

    Blockly.defineBlocksWithJsonArray([
      {
        "type": "parallel_execution",
        "message0": "Parallel Executor %1",
        "args0": [
          {
            "type": "field_dropdown",
            "name": "MODE",
            "options": [
              ["NO WAIT", "NO WAIT"],
              ["WAIT UNTIL", "WAIT UNTIL"]
            ]
          }
        ],
        "message1": "DO %1",
        "args1": [{
          "type": "input_statement",
          "name": "DO"
        }],
        "previousStatement": null,
        "nextStatement": null,
        "style": "loop_blocks",
        "helpUrl": "%{BKY_CONTROLS_WHILEUNTIL_HELPURL}",
        "extensions": ["controls_whileUntil_tooltip"]
      }
    ]);
    var xmlList = [];
    var blockText = '<xml><block type="parallel_execution"></block></xml>';
    var block = Blockly.Xml.textToDom(blockText).firstChild;
    xmlList.push(block);


    Blockly.defineBlocksWithJsonArray([
      {
        "type": "parallel_execution_with_foreach_wait_until",
        "message0": "%{BKY_CONTROLS_FOREACH_TITLE} execute in parallel WAIT UNTIL",
        "args0": [
          {
            "type": "field_variable",
            "name": "VAR",
            "variable": null
          },
          {
            "type": "input_value",
            "name": "LIST",
            "check": "Array"
          }
        ],
        "message1": "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
        "args1": [{
          "type": "input_statement",
          "name": "DO"
        }],
        "previousStatement": null,
        "nextStatement": null,
        "style": "loop_blocks",
        "helpUrl": "%{BKY_CONTROLS_FOREACH_HELPURL}",
        "extensions": [
          "contextMenu_newGetVariableBlock",
          "controls_forEach_tooltip"
        ]
      }
    ]);

    // var xmlList = [];
    var blockText = '<xml><block type="parallel_execution_with_foreach_wait_until"></block></xml>';
    var block = Blockly.Xml.textToDom(blockText).firstChild;
    xmlList.push(block);

    Blockly.defineBlocksWithJsonArray([
      {
        "type": "parallel_execution_with_foreach_no_wait",
        "message0": "%{BKY_CONTROLS_FOREACH_TITLE} execute in parallel NO WAIT",
        "args0": [
          {
            "type": "field_variable",
            "name": "VAR",
            "variable": null
          },
          {
            "type": "input_value",
            "name": "LIST",
            "check": "Array"
          }
        ],
        "message1": "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
        "args1": [{
          "type": "input_statement",
          "name": "DO"
        }],
        "previousStatement": null,
        "nextStatement": null,
        "style": "loop_blocks",
        "helpUrl": "%{BKY_CONTROLS_FOREACH_HELPURL}",
        "extensions": [
          "contextMenu_newGetVariableBlock",
          "controls_forEach_tooltip"
        ]
      }
    ]);

    // var xmlList = [];
    var blockText = '<xml><block type="parallel_execution_with_foreach_no_wait"></block></xml>';
    var block = Blockly.Xml.textToDom(blockText).firstChild;
    xmlList.push(block);


    return xmlList;
  }

  loadJsonObjects() {
    Blockly.defineBlocksWithJsonArray([
      {
        'type': 'key_value_pair',
        'message0': '%1 %2 %3',
        'args0': [
          {
            'type': 'input_value',
            'name': 'A'
          },
          {
            'type': 'field_dropdown',
            'name': 'OP',
            'options': [
              [':', 'COLON']
            ]
          },
          {
            'type': 'input_value',
            'name': 'B'
          }
        ],
        'inputsInline': true,
        'output': 'Boolean',
        'style': 'logic_blocks',
        'helpUrl': '%{BKY_LOGIC_COMPARE_HELPURL}',
        'extensions': ['logic_compare', 'logic_op_tooltip']
      }
    ]);

    Blockly.Constants.Logic.LOGIC_COMPARE_ONCHANGE_MIXIN = {
      onchange: function(e) {
        if (!this.prevBlocks_) {
          this.prevBlocks_ = [null, null];
        }

        var blockA = this.getInputTargetBlock('A');
        var blockB = this.getInputTargetBlock('B');
        // Disconnect blocks that existed prior to this change if they don't match.
        // if (blockA && blockB &&
        //     !blockA.outputConnection.checkType_(blockB.outputConnection)) {
        //     // Mismatch between two inputs.  Revert the block connections,
        //     // bumping away the newly connected block(s).
        //     Blockly.Events.setGroup(e.group);
        //     var prevA = this.prevBlocks_[0];
        //     if (prevA !== blockA) {
        //         blockA.unplug();
        //         if (prevA && !prevA.isShadow()) {
        //             // The shadow block is automatically replaced during unplug().
        //             this.getInput('A').connection.connect(prevA.outputConnection);
        //         }
        //     }
        //     var prevB = this.prevBlocks_[1];
        //     if (prevB !== blockB) {
        //         blockB.unplug();
        //         if (prevB && !prevB.isShadow()) {
        //             // The shadow block is automatically replaced during unplug().
        //             this.getInput('B').connection.connect(prevB.outputConnection);
        //         }
        //     }
        //     this.bumpNeighbours_();
        //     Blockly.Events.setGroup(false);
        // }
        this.prevBlocks_[0] = this.getInputTargetBlock('A');
        this.prevBlocks_[1] = this.getInputTargetBlock('B');
      }
    };
    Blockly.Constants.Logic.LOGIC_COMPARE_EXTENSION = function() {
      // Add onchange handler to ensure types are compatible.
      this.mixin(Blockly.Constants.Logic.LOGIC_COMPARE_ONCHANGE_MIXIN);
    };

    // Blockly.Extensions.register('json_key_value_pair',
    //     Blockly.Constants.Logic.LOGIC_COMPARE_EXTENSION);

    Blockly.Blocks['text_split'] = {
      /**
       * Block for replacing one string with another in the text.
       * @this Blockly.Block
       */
      init: function() {
        this.jsonInit({
          "message0": 'split %1 with %2',
          "args0": [
            {
              "type": "input_value",
              "name": "TEXT",
              "check": "String"
            },
            {
              "type": "input_value",
              "name": "WITH",
              "check": "String"
            }
          ],
          "output": "String",
          "inputsInline": true,
          "style": "text_blocks",
          "tooltip": 'Split text with some text',
          "helpUrl": 'https://github.com/google/blockly/wiki/Text#reversing-text'
        });
      }
    };

    Blockly.Blocks['lists_append'] = {
      /**
       * Block for setting the element at index.
       * @this Blockly.Block
       */
      init: function() {
        var MODE =
            [
              [Blockly.Msg['LISTS_SET_INDEX_SET'], 'SET'],
              [Blockly.Msg['LISTS_SET_INDEX_INSERT'], 'INSERT']
            ];
        this.WHERE_OPTIONS =
            [
              [Blockly.Msg['LISTS_GET_INDEX_FROM_START'], 'FROM_START'],
              [Blockly.Msg['LISTS_GET_INDEX_FROM_END'], 'FROM_END'],
              [Blockly.Msg['LISTS_GET_INDEX_FIRST'], 'FIRST'],
              [Blockly.Msg['LISTS_GET_INDEX_LAST'], 'LAST'],
              [Blockly.Msg['LISTS_GET_INDEX_RANDOM'], 'RANDOM']
            ];
        this.setHelpUrl(Blockly.Msg['LISTS_SET_INDEX_HELPURL']);
        this.setStyle('list_blocks');
        this.appendValueInput('LIST')
            .setCheck('Array')
            .appendField('in list');
        // this.appendDummyInput()
        //     .appendField(new Blockly.FieldDropdown(MODE), 'MODE')
        //     .appendField('', 'SPACE');

        // this.appendDummyInput('AT');
        this.appendValueInput('APPEND')
            .appendField('append');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip(Blockly.Msg['LISTS_SET_INDEX_TOOLTIP']);
        this.updateAt_(true);
        // Assign 'this' to a variable for use in the tooltip closure below.
        var thisBlock = this;
        this.setTooltip('Append items to the list');
      },
      /**
       * Create XML to represent whether there is an 'AT' input.
       * @return {Element} XML storage element.
       * @this Blockly.Block
       */
      mutationToDom: function() {
        var container = Blockly.utils.xml.createElement('mutation');
        // var isAt = this.getInput('AT').type == Blockly.INPUT_VALUE;
        // container.setAttribute('at', isAt);
        return container;
      },
      /**
       * Parse XML to restore the 'AT' input.
       * @param {!Element} xmlElement XML storage element.
       * @this Blockly.Block
       */
      domToMutation: function(xmlElement) {
        // Note: Until January 2013 this block did not have mutations,
        // so 'at' defaults to true.
        // var isAt = (xmlElement.getAttribute('at') != 'false');
        // this.updateAt_(isAt);
      },
      /**
       * Create or delete an input for the numeric index.
       * @param {boolean} isAt True if the input should exist.
       * @private
       * @this Blockly.Block
       */
      updateAt_: function(isAt) {
        // Destroy old 'AT' and 'ORDINAL' input.
        // this.removeInput('AT');
        // this.removeInput('ORDINAL', true);
        // // Create either a value 'AT' input or a dummy input.
        // if (isAt) {
        //     this.appendValueInput('AT').setCheck('Number');
        //     if (Blockly.Msg['ORDINAL_NUMBER_SUFFIX']) {
        //         this.appendDummyInput('ORDINAL')
        //             .appendField(Blockly.Msg['ORDINAL_NUMBER_SUFFIX']);
        //     }
        // } else {
        //     this.appendDummyInput('AT');
        // }
        // var menu = new Blockly.FieldDropdown(this.WHERE_OPTIONS, function(value) {
        //     var newAt = (value == 'FROM_START') || (value == 'FROM_END');
        //     // The 'isAt' variable is available due to this function being a closure.
        //     if (newAt != isAt) {
        //         var block = this.getSourceBlock();
        //         block.updateAt_(newAt);
        //         // This menu has been destroyed and replaced.  Update the replacement.
        //         block.setFieldValue(value, 'WHERE');
        //         return null;
        //     }
        //     return undefined;
        // });
        // this.moveInputBefore('AT', 'TO');
        if (this.getInput('ORDINAL')) {
          this.moveInputBefore('ORDINAL', 'APPEND');
        }

        // this.getInput('AT').appendField(menu, 'WHERE');
      }
    };

    Blockly.Blocks['lists_contains'] = {
      /**
       * Block for creating a list with any number of elements of any type.
       * @this Blockly.Block
       */
      init: function() {
        this.setHelpUrl(Blockly.Msg['LISTS_CREATE_WITH_HELPURL']);
        this.setStyle('list_blocks');
        this.appendValueInput('LIST')
            .setCheck('Array')
            .appendField('check list');
        this.itemCount_ = 3;
        this.updateShape_();
        this.setOutput(true, 'Boolean');
        this.setMutator(new Blockly.Mutator(['lists_create_with_item']));
        this.setTooltip(Blockly.Msg['LISTS_CREATE_WITH_TOOLTIP']);
      },
      /**
       * Create XML to represent list inputs.
       * @return {!Element} XML storage element.
       * @this Blockly.Block
       */
      mutationToDom: function() {
        var container = Blockly.utils.xml.createElement('mutation');
        container.setAttribute('items', this.itemCount_);
        return container;
      },
      /**
       * Parse XML to restore the list inputs.
       * @param {!Element} xmlElement XML storage element.
       * @this Blockly.Block
       */
      domToMutation: function(xmlElement) {
        this.itemCount_ = parseInt(xmlElement.getAttribute('items'), 10);
        this.updateShape_();
      },
      /**
       * Populate the mutator's dialog with this block's components.
       * @param {!Blockly.Workspace} workspace Mutator's workspace.
       * @return {!Blockly.Block} Root block in mutator.
       * @this Blockly.Block
       */
      decompose: function(workspace) {
        var containerBlock = workspace.newBlock('lists_create_with_container');
        containerBlock.initSvg();
        var connection = containerBlock.getInput('STACK').connection;
        for (var i = 0; i < this.itemCount_; i++) {
          var itemBlock = workspace.newBlock('lists_create_with_item');
          itemBlock.initSvg();
          connection.connect(itemBlock.previousConnection);
          connection = itemBlock.nextConnection;
        }
        return containerBlock;
      },
      /**
       * Reconfigure this block based on the mutator dialog's components.
       * @param {!Blockly.Block} containerBlock Root block in mutator.
       * @this Blockly.Block
       */
      compose: function(containerBlock) {
        var itemBlock = containerBlock.getInputTargetBlock('STACK');
        // Count number of inputs.
        var connections = [];
        while (itemBlock) {
          connections.push(itemBlock.valueConnection_);
          itemBlock = itemBlock.nextConnection &&
              itemBlock.nextConnection.targetBlock();
        }
        // Disconnect any children that don't belong.
        for (var i = 0; i < this.itemCount_; i++) {
          var connection = this.getInput('ADD' + i).connection.targetConnection;
          if (connection && connections.indexOf(connection) == -1) {
            connection.disconnect();
          }
        }
        this.itemCount_ = connections.length;
        this.updateShape_();
        // Reconnect any child blocks.
        for (var i = 0; i < this.itemCount_; i++) {
          Blockly.Mutator.reconnect(connections[i], this, 'ADD' + i);
        }
      },
      /**
       * Store pointers to any connected child blocks.
       * @param {!Blockly.Block} containerBlock Root block in mutator.
       * @this Blockly.Block
       */
      saveConnections: function(containerBlock) {
        var itemBlock = containerBlock.getInputTargetBlock('STACK');
        var i = 0;
        while (itemBlock) {
          var input = this.getInput('ADD' + i);
          itemBlock.valueConnection_ = input && input.connection.targetConnection;
          i++;
          itemBlock = itemBlock.nextConnection &&
              itemBlock.nextConnection.targetBlock();
        }
      },
      /**
       * Modify this block to have the correct number of inputs.
       * @private
       * @this Blockly.Block
       */
      updateShape_: function() {
        if (this.itemCount_ && this.getInput('EMPTY')) {
          this.removeInput('EMPTY');
        } else if (!this.itemCount_ && !this.getInput('EMPTY')) {
          this.appendDummyInput('EMPTY')
              .appendField(Blockly.Msg['LISTS_CREATE_EMPTY_TITLE']);
        }
        // Add new inputs.
        for (var i = 0; i < this.itemCount_; i++) {
          if (!this.getInput('ADD' + i)) {
            var input = this.appendValueInput('ADD' + i);
            if (i == 0) {
              input.appendField('contains items');
            }
          }
        }
        // Remove deleted inputs.
        while (this.getInput('ADD' + i)) {
          this.removeInput('ADD' + i);
          i++;
        }
      }
    };

    Blockly.Blocks['lists_splice'] = {
      init: function() {
        this.appendValueInput("list")
            .setCheck(null)
            .appendField("in list");
        this.appendValueInput("start_index")
            .setCheck(null)
            .appendField("splice from");
        this.appendValueInput("end_index")
            .setCheck(null)
            .appendField("to");
        this.setInputsInline(true);
        this.setOutput(true, null);
        this.setColour(255);
        this.setTooltip("");
        this.setHelpUrl("");
      }
    };

    Blockly.Blocks['json_object'] = {
      init: function() {
        this.setHelpUrl(Blockly.Msg['LISTS_CREATE_WITH_HELPURL']);
        this.setStyle('list_blocks');
        this.itemCount_ = 3;
        this.updateShape_();
        this.setOutput(true, 'Array');
        this.setMutator(new Blockly.Mutator(['lists_create_with_item']));
        this.setTooltip('Construct a JSON Object with key value pairs');
      },
      mutationToDom: function() {
        var container = Blockly.utils.xml.createElement('mutation');
        container.setAttribute('items', this.itemCount_);
        return container;
      },
      domToMutation: function(xmlElement) {
        this.itemCount_ = parseInt(xmlElement.getAttribute('items'), 10);
        this.updateShape_();
      },
      decompose: function(workspace) {
        var containerBlock = workspace.newBlock('lists_create_with_container');
        containerBlock.initSvg();
        var connection = containerBlock.getInput('STACK').connection;
        for (var i = 0; i < this.itemCount_; i++) {
          var itemBlock = workspace.newBlock('lists_create_with_item');
          itemBlock.initSvg();
          connection.connect(itemBlock.previousConnection);
          connection = itemBlock.nextConnection;
        }
        return containerBlock;
      },
      compose: function(containerBlock) {
        var itemBlock = containerBlock.getInputTargetBlock('STACK');
        // Count number of inputs.
        var connections = [];
        while (itemBlock) {
          connections.push(itemBlock.valueConnection_);
          itemBlock = itemBlock.nextConnection &&
              itemBlock.nextConnection.targetBlock();
        }
        // Disconnect any children that don't belong.
        for (var i = 0; i < this.itemCount_; i++) {
          var connection = this.getInput('ADD' + i).connection.targetConnection;
          if (connection && connections.indexOf(connection) == -1) {
            connection.disconnect();
          }
        }
        this.itemCount_ = connections.length;
        this.updateShape_();
        // Reconnect any child blocks.
        for (var i = 0; i < this.itemCount_; i++) {
          Blockly.Mutator.reconnect(connections[i], this, 'ADD' + i);
        }
      },
      saveConnections: function(containerBlock) {
        var itemBlock = containerBlock.getInputTargetBlock('STACK');
        var i = 0;
        while (itemBlock) {
          var input = this.getInput('ADD' + i);
          itemBlock.valueConnection_ = input && input.connection.targetConnection;
          i++;
          itemBlock = itemBlock.nextConnection &&
              itemBlock.nextConnection.targetBlock();
        }
      },
      updateShape_: function() {
        if (this.itemCount_ && this.getInput('EMPTY')) {
          this.removeInput('EMPTY');
        } else if (!this.itemCount_ && !this.getInput('EMPTY')) {
          this.appendDummyInput('EMPTY').appendField('create JSON object');
          // .appendField(Blockly.Msg['LISTS_CREATE_EMPTY_TITLE']);
        }
        // Add new inputs.
        for (var i = 0; i < this.itemCount_; i++) {
          if (!this.getInput('ADD' + i)) {
            var input = this.appendValueInput('ADD' + i);
            if (i == 0) {
              input.appendField('create JSON object');
            }
          }
        }
        // Remove deleted inputs.
        while (this.getInput('ADD' + i)) {
          this.removeInput('ADD' + i);
          i++;
        }
      }
    };

    Blockly.Blocks['get_keys_from_json_object'] = {
      init: function() {
        this.appendValueInput('NAME')
            .setCheck(null)
            .setAlign(Blockly.ALIGN_CENTRE)
            .appendField(' get keys from JSON object');
        this.setOutput(true, null);
        this.setColour(330);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['get_a_key_from_json_object'] = {
      init: function() {
        this.appendValueInput('key')
            .setCheck(null)
            .setAlign(Blockly.ALIGN_CENTRE)
            .appendField(' get value of key');
        this.appendValueInput('object')
            .setCheck(null)
            .appendField('from JSON object');
        this.setInputsInline(true);
        this.setOutput(true, null);
        this.setColour(45);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['execute_api'] = {
      init: function() {
        this.appendValueInput('NAME')
            .setCheck(null)
            .setAlign(Blockly.ALIGN_CENTRE)
            .appendField('execute API');
        this.setOutput(true, null);
        this.setColour(315);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['parse_json'] = {
      init: function() {
        this.appendValueInput('Name')
            .setCheck(null)
            .appendField('parse string to JSON');
        this.setOutput(true, null);
        this.setColour(120);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['parse_int'] = {
      init: function() {
        this.appendValueInput('Name')
            .setCheck(null)
            .appendField('Integer of');
        this.setOutput(true, null);
        this.setColour(130);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['parse_long'] = {
      init: function() {
        this.appendValueInput('Name')
            .setCheck(null)
            .appendField('Long of');
        this.setOutput(true, null);
        this.setColour(140);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['parse_double'] = {
      init: function() {
        this.appendValueInput('Name')
            .setCheck(null)
            .appendField('Double of');
        this.setOutput(true, null);
        this.setColour(150);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['parse_string'] = {
      init: function() {
        this.appendValueInput('Name')
            .setCheck(null)
            .appendField('String of');
        this.setOutput(true, null);
        this.setColour(160);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['parse_boolean'] = {
      init: function() {
        this.appendValueInput('Name')
            .setCheck(null)
            .appendField('Boolean of');
        this.setOutput(true, null);
        this.setColour(170);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['parse_date'] = {
      init: function() {
        this.appendValueInput('Name')
            .setCheck(null)
            .appendField('Date of');
        this.setOutput(true, null);
        this.setColour(180);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };
    Blockly.Blocks['parse_timestamp'] = {
      init: function() {
        this.appendValueInput('Name')
            .setCheck(null)
            .appendField('Timestamp of');
        this.setOutput(true, null);
        this.setColour(190);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['parse_float'] = {
      init: function() {
        this.appendValueInput('Name')
            .setCheck(null)
            .appendField('Float of');
        this.setOutput(true, null);
        this.setColour(200);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['parse_character'] = {
      init: function() {
        this.appendValueInput('Name')
            .setCheck(null)
            .appendField('Character of');
        this.setOutput(true, null);
        this.setColour(210);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['parse_byte'] = {
      init: function() {
        this.appendValueInput('Name')
            .setCheck(null)
            .appendField('Byte of');
        this.setOutput(true, null);
        this.setColour(220);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['parse_short'] = {
      init: function() {
        this.appendValueInput('Name')
            .setCheck(null)
            .appendField('Short of');
        this.setOutput(true, null);
        this.setColour(230);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['datatype_of'] = {
      init: function() {
        this.appendValueInput("value")
            .setCheck(null)
            .appendField("Datatype of");
        this.setInputsInline(false);
        this.setOutput(true, null);
        this.setColour(0);
        this.setTooltip("");
        this.setHelpUrl("");
      }
    };

    Blockly.Blocks['pass_parameters_to_api_executor'] = {
      init: function() {
        this.appendValueInput('NAME')
            .setCheck(null)
            .appendField('pass dynamic parameters to API executor');
        this.setOutput(true, null);
        this.setColour(230);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['connect_workbook'] = {
      init: function() {
        this.appendValueInput("connection")
            .setCheck(null)
            .appendField("Connect Workbook");
        this.appendStatementInput("statements")
            .setCheck(null)
            .appendField("do");
        this.setInputsInline(false);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(0);
        this.setTooltip("");
        this.setHelpUrl("");
      }
    };

    Blockly.Blocks['read_worksheet_cell'] = {
      init: function() {
        this.appendValueInput("worksheet")
            .setCheck(null)
            .appendField("(Read cell) From worksheet");
        this.appendValueInput("row")
            .setCheck(null)
            .appendField("Row");
        this.appendValueInput("column")
            .setCheck(null)
            .appendField("Column");
        this.setInputsInline(false);
        this.setOutput(true, null);
        this.setColour(180);
        this.setTooltip("");
        this.setHelpUrl("");
      }
    };

    Blockly.Blocks['write_cell_to_worksheet'] = {
      init: function() {
        this.appendValueInput("worksheet")
            .setCheck(null)
            .appendField("(Write Cell) Worksheet");
        this.appendValueInput("row")
            .setCheck(null)
            .appendField("Row");
        this.appendValueInput("column")
            .setCheck(null)
            .appendField("Column");
        this.appendValueInput("value")
            .setCheck(null)
            .appendField("Value");
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(230);
        this.setTooltip("");
        this.setHelpUrl("");
      }
    };

    Blockly.Blocks['worksheet_url'] = {
      init: function() {
        this.appendValueInput("worksheet_url")
            .setCheck(null)
            .appendField("worksheet URL");
        this.setOutput(true, null);
        this.setColour(120);
        this.setTooltip("");
        this.setHelpUrl("");
      }
    };

    Blockly.Blocks['current_timestamp'] = {
      init: function () {
        this.appendDummyInput()
            .appendField('current timestamp');
        this.setOutput(true, null);
        this.setColour(240);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['current_date'] = {
      init: function () {
        this.appendDummyInput()
            .appendField('current date');
        this.setOutput(true, null);
        this.setColour(240);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['current_date_with_format'] = {
      init: function () {
        this.appendDummyInput()
            .appendField('current date');
        this.appendValueInput('format')
            .setCheck(null)
            .appendField('with format');
        this.setInputsInline(true);
        this.setOutput(true, null);
        this.setColour(240);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['current_date_time'] = {
      init: function () {
        this.appendDummyInput()
            .appendField('current date time');
        this.setOutput(true, null);
        this.setColour(240);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['current_date_time_with_format'] = {
      init: function () {
        this.appendDummyInput()
            .appendField('current date time');
        this.appendValueInput('format')
            .setCheck(null)
            .appendField('with format');
        this.setInputsInline(true);
        this.setOutput(true, null);
        this.setColour(240);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['date_arithmetic'] = {
      init: function () {
        this.appendDummyInput()
            .appendField(new Blockly.FieldDropdown([["add","add"], ["subtract","subtract"]]), "operation");
        this.appendValueInput('value')
            .setCheck('Number')
            .appendField('value');
        this.appendDummyInput()
            .appendField(new Blockly.FieldDropdown([["years","years"], ["months","months"], ["days","days"], ["hours","hours"], ["minutes","minutes"], ["seconds","seconds"]]), "unit");
        this.appendDummyInput()
            .appendField('to/from');
        this.appendValueInput('datefield')
            .setCheck(null)
            .appendField('date');

        this.setInputsInline(true);
        this.setOutput(true, null);
        this.setColour(240);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['get_date_attribute'] = {
      init: function () {
        this.appendDummyInput().appendField('get')
            .appendField(new Blockly.FieldDropdown([["year","year"], ["month","month"], ["day","day"], ["dayOfYear","dayOfYear"], ["dayOfMonth","dayOfMonth"],["dayOfWeek","dayOfWeek"],["hour","hour"],["minute","minute"],["second","second"],["nano","nano"]]), 'attribute');
        this.appendDummyInput()
            .appendField('of date');
        this.appendValueInput('datefield')
            .setCheck(null);
        this.setInputsInline(true);
        this.setOutput(true, null);
        this.setColour(240);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };
    Blockly.Blocks['parse_date_from_string_with_format'] = {
      init: function () {
        this.appendValueInput('datefield')
            .setCheck(null)
            .appendField('parse string');
        this.appendValueInput('format')
            .setCheck(null)
            .appendField('to date with format');
        this.setInputsInline(true);
        this.setOutput(true, null);
        this.setColour(240);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['format_date_with_string_formatter'] = {
      init: function () {
        this.appendValueInput('datefield')
            .setCheck(null)
            .appendField('format datefield');
        this.appendValueInput('format')
            .setCheck(null)
            .appendField('with format');
        this.appendDummyInput()
            .appendField('returns string');
        this.setInputsInline(true);
        this.setOutput(true, null);
        this.setColour(240);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['parse_date_from_string'] = {
      init: function () {
        this.appendValueInput('datefield')
            .setCheck(null)
            .appendField('parse string');
        this.appendDummyInput()
            .appendField('to date at yyyy-MM-dd');
        this.setInputsInline(true);
        this.setOutput(true, null);
        this.setColour(240);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['read_csv'] = {
      init: function() {
        this.appendDummyInput()
            .appendField("read CSV");
        this.appendValueInput("url")
            .setCheck(null)
            .appendField("URL");
        this.appendValueInput("s3_connector")
            .setCheck(null)
            .appendField("S3 connector");
        this.setOutput(true, null);
        this.setColour(230);
        this.setTooltip("");
        this.setHelpUrl("");
      }
    };

    Blockly.Blocks['write_csv'] = {
      init: function() {
        this.appendDummyInput()
            .appendField("write CSV");
        this.appendValueInput("folder")
            .setCheck(null)
            .appendField("folder");
        this.appendValueInput("file_name")
            .setCheck(null)
            .appendField("file name");
        this.appendValueInput("content")
            .setCheck(null)
            .appendField("content");
        this.appendValueInput("s3_connector")
            .setCheck(null)
            .appendField("S3 connector");
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(230);
        this.setTooltip("");
        this.setHelpUrl("");
      }
    };

    Blockly.Blocks['write_csv_block'] = {
      init: function() {
        this.appendDummyInput()
            .appendField("write CSV");
        this.appendValueInput("folder")
            .setCheck(null)
            .appendField("folder");
        this.appendValueInput("file_name")
            .setCheck(null)
            .appendField("file name");
        this.appendValueInput("content")
            .setCheck(null)
            .appendField("content");
        this.appendValueInput("s3_connector")
            .setCheck(null)
            .appendField("S3 connector");
        this.setOutput(true, null);
        this.setColour(230);
        this.setTooltip("");
        this.setHelpUrl("");
      }
    };

    Blockly.Blocks['read_file_input_bytes'] = {
      init: function () {
        this.appendValueInput('read_file_input_bytes')
            .setCheck(null)
            .appendField('read file URL as bytes');
        this.setOutput(true, null);
        this.setColour(230);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['text_decode_base64'] = {
      init: function () {
        this.appendValueInput('text_decode_base64')
            .setCheck(null)
            .appendField('decode base64');
        this.setOutput(true, null);
        this.setColour(160);
        this.setTooltip('Decode base64 encoded string');
        this.setHelpUrl('');
      }
    };

    Blockly.JavaScript['text_decode_base64'] = function(block) {
      var text = Blockly.JavaScript.valueToCode(block, 'VALUE',
          Blockly.JavaScript.ORDER_FUNCTION_CALL) || '\'\'';
      return ['decodebase64(' + text + ')', Blockly.JavaScript.ORDER_MEMBER];
    };


    Blockly.Blocks['text_decode_zip_content_bytes'] = {
      init: function () {
        this.appendValueInput('text_decode_zip_content_bytes')
            .setCheck(null)
            .appendField('decode ContentBytes of zip');
        this.setOutput(true, null);
        this.setColour(160);
        this.setTooltip('Decode ContentBytes of zip');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['replace_key_in_json'] = {
      init: function () {
        this.appendValueInput('KEY')
            .setCheck(null)
            .appendField('Replace key');
        this.appendValueInput('VALUE')
            .setCheck(null)
            .appendField('with value');
        this.appendValueInput('JSON')
            .setCheck(null)
            .appendField('in JSON ');
        this.setInputsInline(true);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(0);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };
    Blockly.Blocks['insert_key_value_pair_in_json'] = {
      init: function () {
        this.appendValueInput('KEY')
            .setCheck(null)
            .appendField('Insert key value pair');
        this.appendValueInput('JSON')
            .setCheck(null)
            .appendField('into JSON ');
        this.setInputsInline(true);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(0);
        this.setTooltip('Insert Key Value Pair into JSON');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['remove_key_from_json'] = {
      init: function () {
        this.appendValueInput('key')
            .setCheck(null)
            .appendField('Remove key');
        this.appendValueInput('json')
            .setCheck(null)
            .appendField('from JSON');
        this.setInputsInline(true);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(285);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };

    Blockly.Blocks['text_substring_count'] = {
      init: function () {
        this.appendValueInput('substring')
            .setCheck(null)
            .appendField('get the count of');
        this.appendValueInput('from_text')
            .setCheck(null)
            .appendField('in');
        this.setInputsInline(true);
        this.setOutput(true, null);
        this.setColour(160);
        this.setTooltip('');
        this.setHelpUrl('');
      }
    };
  }

  loadExecutorBlockBasedOnEntity(entityNames) {

    let name = entityNames.split('_');
    let xmlList = [];
    const that = this;

    this.items.forEach((catExe) => {
      if (catExe && catExe['executors'] && catExe['executors'] !== null && catExe['executors'] !== undefined) {
        catExe.executors.forEach((exect) => {
          if (exect && exect !== null && exect !== undefined && exect.executor_name && exect.executor_name != null) {
            if (exect.executor_category === name[0] && exect.executor_version === name[1]){
              let params;
              Blockly.Blocks[exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version] = {
                init: function () {

                  if (exect.executor_method_type === 'GET') {
                    this.setColour(100);
                  } else if (exect.executor_method_type === 'POST') {
                    this.setColour(220);
                  } else if (exect.executor_method_type === 'PUT') {
                    this.setColour(45);
                  } else if (exect.executor_method_type === 'DELETE') {
                    this.setColour(0);
                  } else {
                    this.setColour(160);
                  }
                  this.setTooltip((exect.executor_category_group !== null ? exect.executor_category_group + ' > ' : null) + exect.executor_category);
                  this.setNextStatement(true);
                  this.setPreviousStatement(true);
                  this.appendDummyInput()
                      .appendField(exect.executor_name + '(' + exect.executor_version + ')');

                  this.appendValueInput('headers').appendField('headers');
                  this.appendValueInput('parameters').appendField('parameters');
                  this.appendValueInput('path_parameters').appendField('path_parameters');
                  // this.appendValueInput('request_body').appendField('request_body');
                  this.appendValueInput('authorization').appendField('authorization');

                  const blockThis = this;
                  if (exect.headers != null) {
                    var headerBlock = blockThis.workspace.newBlock('json_object');
                    headerBlock.itemCount_ = 0;
                    headerBlock.updateShape_();
                    var i = 0;
                    exect.headers.forEach((attr) => {
                      if (attr && attr.key && attr.key != null) {
                        headerBlock.appendValueInput('ADD' + i);
                        var key_value_1 = headerBlock.workspace.newBlock('key_value_pair');

                        var keyBlock = key_value_1.workspace.newBlock('text');
                        keyBlock.setFieldValue(attr.key, 'TEXT');
                        key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                        var valueBlock = key_value_1.workspace.newBlock('text');
                        valueBlock.setFieldValue(attr.value, 'TEXT');
                        key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);

                        headerBlock.getInput('ADD' + i).connection.connect(key_value_1.outputConnection);
                        i++;
                      }

                    });
                    headerBlock.itemCount_ = i;
                    headerBlock.updateShape_();
                    blockThis.getInput('headers').connection.connect(headerBlock.outputConnection);

                  } else {

                  }
                  if (exect.queryParams != null) {
                    var queryParamsBlock = blockThis.workspace.newBlock('json_object');
                    queryParamsBlock.itemCount_ = 0;
                    queryParamsBlock.updateShape_();
                    var j = 0;
                    exect.queryParams.forEach((attr) => {
                      if (attr && attr.key && attr.key != null) {
                        queryParamsBlock.appendValueInput('ADD' + j);

                        var key_value_1 = queryParamsBlock.workspace.newBlock('key_value_pair');
                        var keyBlock = key_value_1.workspace.newBlock('text');
                        keyBlock.setFieldValue(attr.key, 'TEXT');
                        key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);
                        var valueBlock = key_value_1.workspace.newBlock('text');
                        valueBlock.setFieldValue(attr.value, 'TEXT');
                        key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);

                        queryParamsBlock.getInput('ADD' + j).connection.connect(key_value_1.outputConnection);
                        j++;
                      }

                    });
                    queryParamsBlock.itemCount_ = j;
                    queryParamsBlock.updateShape_();
                    blockThis.getInput('parameters').connection.connect(queryParamsBlock.outputConnection);

                  } else {

                  }
                  if (exect.pathParams != null) {
                    var pathParamsBlock = blockThis.workspace.newBlock('json_object');
                    pathParamsBlock.itemCount_ = 0;
                    pathParamsBlock.updateShape_();
                    var k = 0;
                    exect.pathParams.forEach((attr) => {
                      if (attr && attr.key && attr.key != null) {
                        pathParamsBlock.appendValueInput('ADD' + k);
                        var key_value_1 = pathParamsBlock.workspace.newBlock('key_value_pair');

                        var keyBlock = key_value_1.workspace.newBlock('text');
                        keyBlock.setFieldValue(attr.key, 'TEXT');
                        key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                        var valueBlock = key_value_1.workspace.newBlock('text');
                        valueBlock.setFieldValue(attr.value, 'TEXT');
                        key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);

                        pathParamsBlock.getInput('ADD' + k).connection.connect(key_value_1.outputConnection);
                        k++;
                      }

                    });
                    pathParamsBlock.itemCount_ = k;
                    pathParamsBlock.updateShape_();
                    blockThis.getInput('path_parameters').connection.connect(pathParamsBlock.outputConnection);
                    // }

                  } else {

                  }
                  if (exect.authModel) {
                    if (that.authorizationBlocks) {
                      that.authorizationBlocks.forEach(authBlock => {
                        if (authBlock.name === exect.authModel.authType) {
                          var dynBlock = blockThis.workspace.newBlock(authBlock.name);
                          const authAttributes = authBlock.authAttributes;
                          if (authAttributes) {
                            authAttributes.forEach(attribute => {
                              var dynItemBlock = dynBlock.workspace.newBlock('text');
                              dynItemBlock.setFieldValue(exect.authModel.authAttributes[attribute.key], 'TEXT');
                              dynBlock.getInput(attribute.key).connection.connect(dynItemBlock.outputConnection);
                            });
                          }
                          blockThis.getInput('authorization').connection.connect(dynBlock.outputConnection);

                        }
                      });
                    }
                  }
                  if (exect.requestBody != null) {
                    if (exect.requestBody.hasOwnProperty('__zone_symbol__value')) {
                      blockThis.appendValueInput(exect.requestBody['__zone_symbol__value'].key).appendField(exect.requestBody['__zone_symbol__value'].key);
                    } else if (exect.requestBody.key && exect.requestBody.key != null) {
                      blockThis.appendValueInput(exect.requestBody.key).appendField(exect.requestBody.key);
                      // var numberShadowBlock = blockThis.workspace.newBlock('text');
                      // numberShadowBlock.setFieldValue(exect.requestBody.value, 'TEXT');
                      // blockThis.getInput(exect.requestBody.key).connection.connect(numberShadowBlock.outputConnection);
                      // delete blockThis.workspace.Blocks['text'];
                    }
                  }
                },
                onchange: function (event) {
                  if (event.ids) {
                    if (that.workspace.getBlockById(event.blockId)) {
                      if (that.workspace.getBlockById(event.blockId).type != null) {
                        // if(that.workspace.getBlockById(event.blockId).type && that.workspace.getBlockById(event.blockId).type != null) {
                        // that.findExecutorAttibutes(exect.category, that.workspace.getBlockById(event.blockId).type);
                        that.findExecutorAttibutes(exect.executor_category, that.workspace.getBlockById(event.blockId).type);
                      }
                    }
                  }
                }
              };
              var blockText = '<block type="' + exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version + '"></block>';
              xmlList.push(blockText);
            }
          }

        });
        // }
      }
    });
    return xmlList;
  }

  loadb2bExecutorBlockBasedOnEntity(entityNames, exect, category) {
    let xmlList = [];
    const that = this;
    // this.apiResponseFromServerForB2B.forEach((catExe) => {
    //     catExe.categories.forEach((category) => {
    //         category.executors.forEach((exect) => {
    //             if (exect.executor_name && exect.executor_name != null) {
    const t = exect.executor_category_group + '>' + exect.executor_category;
    if (t === entityNames) {
      let params;
      Blockly.Blocks[exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version] = {
        init: function () {
          if (exect.executor_method_type === 'GET') {
            this.setColour(100);
          } else if (exect.executor_method_type === 'POST') {
            this.setColour(220);
          } else if (exect.executor_method_type === 'PUT') {
            this.setColour(45);
          } else if (exect.executor_method_type === 'DELETE') {
            this.setColour(0);
          } else {
            this.setColour(160);
          }
          this.setTooltip((exect.executor_category_group !== null ? exect.executor_category_group + ' > ' : null) + exect.executor_category);
          this.setNextStatement(true);
          this.setPreviousStatement(true);
          this.appendDummyInput()
              .appendField(exect.executor_name + '(' + exect.executor_version + ')');

          this.appendValueInput('headers').appendField('headers');
          this.appendValueInput('parameters').appendField('parameters');
          this.appendValueInput('path_parameters').appendField('path_parameters');
          // this.appendValueInput('request_body').appendField('request_body');
          this.appendValueInput('authorization').appendField('authorization');

          const blockThis = this;
          if (exect.headers != null) {
            var headerBlock = blockThis.workspace.newBlock('json_object');
            headerBlock.itemCount_ = 0;
            headerBlock.updateShape_();
            var i = 0;
            exect.headers.forEach((attr) => {
              if (attr && attr.key && attr.key != null) {
                headerBlock.appendValueInput('ADD' + i);
                var key_value_1 = headerBlock.workspace.newBlock('key_value_pair');

                var keyBlock = key_value_1.workspace.newBlock('text');
                keyBlock.setFieldValue(attr.key, 'TEXT');
                key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                var valueBlock = key_value_1.workspace.newBlock('text');
                valueBlock.setFieldValue(attr.value, 'TEXT');
                key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);

                headerBlock.getInput('ADD' + i).connection.connect(key_value_1.outputConnection);
                i++;
              }

            });
            headerBlock.itemCount_ = i;
            headerBlock.updateShape_();
            blockThis.getInput('headers').connection.connect(headerBlock.outputConnection);
          } else {

          }
          if (exect.queryParams != null) {
            var queryParamsBlock = blockThis.workspace.newBlock('json_object');
            queryParamsBlock.itemCount_ = 0;
            queryParamsBlock.updateShape_();
            var j = 0;
            exect.queryParams.forEach((attr) => {
              if (attr && attr.key && attr.key != null) {
                queryParamsBlock.itemCount_++;
                queryParamsBlock.appendValueInput('ADD' + j);

                var key_value_1 = queryParamsBlock.workspace.newBlock('key_value_pair');
                var keyBlock = key_value_1.workspace.newBlock('text');
                keyBlock.setFieldValue(attr.key, 'TEXT');
                key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);
                var valueBlock = key_value_1.workspace.newBlock('text');
                valueBlock.setFieldValue(attr.value, 'TEXT');
                key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);

                queryParamsBlock.getInput('ADD' + j).connection.connect(key_value_1.outputConnection);
                j++;
              }

            });
            queryParamsBlock.itemCount_ = j;
            queryParamsBlock.updateShape_();
            blockThis.getInput('parameters').connection.connect(queryParamsBlock.outputConnection);

          } else {

          }
          if (exect.pathParams != null) {
            var pathParamsBlock = blockThis.workspace.newBlock('json_object');
            pathParamsBlock.itemCount_ = 0;
            pathParamsBlock.updateShape_();
            var k = 0;
            exect.pathParams.forEach((attr) => {
              if (attr && attr.key && attr.key != null) {
                pathParamsBlock.appendValueInput('ADD' + k);
                var key_value_1 = pathParamsBlock.workspace.newBlock('key_value_pair');

                var keyBlock = key_value_1.workspace.newBlock('text');
                keyBlock.setFieldValue(attr.key, 'TEXT');
                key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                var valueBlock = key_value_1.workspace.newBlock('text');
                valueBlock.setFieldValue(attr.value, 'TEXT');
                key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);

                pathParamsBlock.getInput('ADD' + k).connection.connect(key_value_1.outputConnection);
                k++;
              }

            });
            pathParamsBlock.itemCount_ = k;
            pathParamsBlock.updateShape_();
            blockThis.getInput('path_parameters').connection.connect(pathParamsBlock.outputConnection);
          } else {

          }
          if (exect.authModel) {
            if (that.authorizationBlocks) {
              that.authorizationBlocks.forEach(authBlock => {
                if (authBlock.name === exect.authModel.authType) {
                  var dynBlock = blockThis.workspace.newBlock(authBlock.name);
                  const authAttributes = authBlock.authAttributes;
                  if (authAttributes) {
                    authAttributes.forEach(attribute => {
                      var dynItemBlock = dynBlock.workspace.newBlock('text');
                      dynItemBlock.setFieldValue(exect.authModel.authAttributes[attribute.key], 'TEXT');
                      dynBlock.getInput(attribute.key).connection.connect(dynItemBlock.outputConnection);

                    });
                  }
                  blockThis.getInput('authorization').connection.connect(dynBlock.outputConnection);

                }
              });
            }


          }
          if (exect.requestBody != null) {
            if (exect.requestBody.key && exect.requestBody.key != null) {
              blockThis.appendValueInput(exect.requestBody.key).appendField(exect.requestBody.key);
              // var numberShadowBlock = blockThis.workspace.newBlock('text');
              // numberShadowBlock.setFieldValue(exect.requestBody.value, 'TEXT');
              // blockThis.getInput(exect.requestBody.key).connection.connect(numberShadowBlock.outputConnection);
              // delete blockThis.workspace.Blocks['text'];
            }
          }
        },
        onchange: function (event) {
          if (event.ids) {
            if (that.workspace.getBlockById(event.blockId)) {
              if (that.workspace.getBlockById(event.blockId).type != null) {
                // if(that.workspace.getBlockById(event.blockId).type && that.workspace.getBlockById(event.blockId).type != null) {
                that.findExecutorAttibutesforB2B(category, that.workspace.getBlockById(event.blockId).type);
              }
            }
          }
        }
      };
      var blockText = '<block type="' + exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version + '"></block>';
      xmlList.push(blockText);
    }
    return xmlList;
  }

  debugApi() {
    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'businesslogic_debug_test_clicked', 'INFO', '', '', '', '', '', this.router.url)).then(response => {
      const payloadToSend = {
        actions: response
      };
      this.businessLogicListenerInstance.businessLogicListener.emit({
        type: 'audit',
        id: localStorage.getItem('IdOfSession'),
        payload: payloadToSend
      });
    });
    // this.debugFlag = true;
    // if (this.debugFlag) {
    //     this.blocklyDivSize = 'col-lg-9 col-md-9 col-sm-12 col-xs-12';
    // } else {
    //     this.blocklyDivSize = 'col-lg-12 col-md-12 col-sm-12 col-xs-12';
    // }
    this.generateExecutorForDebug();
  }

  saveAPI() {

    const saveClickedMessage = this.editFlag === true ? 'businesslogic_edit_save_clicked' : 'businesslogic_create_save_clicked';
    const saveSuccessMessage = this.editFlag === true ? 'businesslogic_edit_save_success' : 'businesslogic_create_save_success';
    const saveFailureMessage = this.editFlag === true ? 'businesslogic_edit_save_failed' : 'businesslogic_create_save_failed';

    var that = this;
    var xml = Blockly.Xml.workspaceToDom(this.workspace);
    var rootNode = xml.getRootNode();

    var idsTobeRemoved = [];
    const blocks = rootNode.childNodes;
    blocks.forEach(blk => {
      if (blk.getAttribute('type') === 'json_object' ||
          blk.getAttribute('type') === 'text' ||
          blk.getAttribute('type') === 'basic_authentication' ||
          blk.getAttribute('type') === 'digest_authentication' ||
          blk.getAttribute('type') === 'connector' ||
          blk.getAttribute('type') === 'api_key' ||
          blk.getAttribute('type') === 'bearer_token' ||
          blk.getAttribute('type') === 'aws' ||
          blk.getAttribute('type') === 'oauth_1_0' ||
          blk.getAttribute('type') === 'oauth_2_0') {
        idsTobeRemoved.push(blk.getAttribute('id'));
      }
    });

    idsTobeRemoved.forEach(id => {
      var children = rootNode.childNodes;
      children.forEach(child => {
        if (id === child.getAttribute('id')) {
          rootNode.removeChild(child);
        }
      });
    });

    var xml_text = Blockly.Xml.domToText(rootNode);

    const parser = new DOMParser();
    const xml1 = parser.parseFromString(xml_text, 'text/xml');
    const obj = this.ngxXml2jsonService.xmlToJson(xml1);
    if (obj['xml'].block === undefined) {
      if (this.headers) {
        for (let i = 0; i < this.headers.length; i++) {
          if (this.headers[i]) {
            if (this.headers[i]['key'] === '') {
              this.headers.splice(i, 1);
            }
          }
        }
      }
      if (this.queryParams) {
        for (let i = 0; i < this.queryParams.length; i++) {
          if (this.queryParams[i]) {
            if (this.queryParams[i]['key'] === '') {
              this.queryParams.splice(i, 1);
            }
          }
        }
      }
      if (this.devexHeader.requestBodySelected && this.devexHeader.requestBodySelected !== 'raw' && this.devexHeader.requestBodySelected !== 'binary' && this.devexHeader.requestBodySelected !== 'none') {
        for (let i = 0; i < this.requestBody['value'].length; i++) {
          if (this.requestBody['value'][i]) {
            if (this.requestBody['value'][i]['key'] === '') {
              this.requestBody['value'].splice(i, 1);
            }
          }
        }
      }

      let requestBody = {};
      if (this.requestBody && this.requestBody.hasOwnProperty('__zone_symbol__value')) {
        requestBody = this.requestBody['__zone_symbol__value'];
      } else {
        requestBody = this.requestBody;
      }

      const fabResult = {
        'executor_type': this.selectedExecutorType,
        'executor_name': this.executor_name,
        'executor_version': this.selectedVersion,
        'executor_display_name': this.executor_display_name,
        'executor_description': this.description,
        'executor_category': this.executorCategory,
        'published': true,
        'scopeOfAccess': this.scopeSelected,
        'creationTime': Date.now(),
        'lastModifiedTime': Date.now(),
        'registeredAsIs': false,
        'executor_method_type': this.selectedExecutor,
        'queryParams': this.queryParams,
        'headers': this.headers,
        'requestBody': requestBody,
        'source': xml_text,
        'executors': [],
        'partner': this.partner,
        'account_id': this.account_id,
        'apiUrl': this.gatewayFullUrl + '/' + this.selectedVersion + '/' + this.executor_name,
        // 'apiUrl': environment.konghost + '/' + this.selectedVersion + '/' + this.partner + '/' + this.account + '/' + this.executor_name,
        'dataroot': null,
        'responseAttributes': null,
        'attributeMappings': null,
        'response': null,
        'block_attributes': this.attributeList
      };
      if (this.prerequisites !== null && this.prerequisites !== undefined) {
        fabResult['prerequisites'] = this.prerequisites;
      }

      fabResult['authModel'] = this.devexHeader.authModel1.getAuthModel();

      if (this.emitSaveApi) {
        this.saveBlocks.emit(fabResult);
      } else {
        this.platform.openSnackBar('The business logic is empty. Please add some blocks to deploy this logic as an API', 'Error', {
          duration: 10000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
      this.loading1 = false;
    } else {
      let JSON_Blocks = {};
      if (obj['xml'].block !== undefined && obj['xml'].block.length > 1) {
        let index = 0;

        obj['xml'].block.forEach((block) => {
          if (block['@attributes'].type !== 'text' &&
              block['@attributes'].type !== 'json_object' &&
              block['@attributes'].type !== 'basic_authentication' &&
              block['@attributes'].type !== 'digest_authentication' &&
              block['@attributes'].type !== 'connector' &&
              block['@attributes'].type !== 'api_key' &&
              block['@attributes'].type !== 'bearer_token' &&
              block['@attributes'].type !== 'aws' &&
              block['@attributes'].type !== 'oauth_1_0' &&
              block['@attributes'].type !== 'oauth_2_0') {
            JSON_Blocks['block'] = obj['xml'].block[index];
          }
          index++;
        });
      } else {
        JSON_Blocks['block'] = obj['xml'].block;
      }

      this.cfgSrv.getExecutorsForBlocks(this.partner, this.account_id, JSON_Blocks).subscribe(executors => {
        this.requestBody = this.devexHeader.getRequestBody();

        if (this.headers) {
          for (let i = 0; i < this.headers.length; i++) {
            if (this.headers[i]) {
              if (this.headers[i]['key'] === '') {
                this.headers.splice(i, 1);
              }
            }
          }
        }
        if (this.queryParams) {
          for (let i = 0; i < this.queryParams.length; i++) {
            if (this.queryParams[i]) {
              if (this.queryParams[i]['key'] === '') {
                this.queryParams.splice(i, 1);
              }
            }
          }
        }
        if (this.devexHeader.requestBodySelected && this.devexHeader.requestBodySelected !== 'raw' && this.devexHeader.requestBodySelected !== 'binary' && this.devexHeader.requestBodySelected !== 'none') {
          for (let i = 0; i < this.requestBody['value'].length; i++) {
            if (this.requestBody['value'][i]) {
              if (this.requestBody['value'][i]['key'] === '') {
                this.requestBody['value'].splice(i, 1);
              }
            }
          }
        }

        let requestBody = {};
        if (this.requestBody.hasOwnProperty('__zone_symbol__value')) {
          requestBody = this.requestBody['__zone_symbol__value'];
        } else {
          requestBody = this.requestBody;
        }

        const fabResult = {
          'executor_type': this.selectedExecutorType,
          'executor_name': this.executor_name,
          'executor_version': this.selectedVersion,
          'executor_display_name': this.executor_display_name,
          'executor_description': this.description,
          'executor_category': this.executorCategory,
          'published': true,
          'scopeOfAccess': this.scopeSelected,
          'creationTime': Date.now(),
          'lastModifiedTime': Date.now(),
          'registeredAsIs': false,
          'executor_method_type': this.selectedExecutor,
          'queryParams': this.queryParams,
          'headers': this.headers,
          'requestBody': requestBody,
          'source': xml_text,
          'executors': executors,
          'partner': this.partner,
          'account_id': this.account_id,
          'apiUrl': this.gatewayFullUrl + '/' + this.selectedVersion + '/' + this.executor_name,
          // 'apiUrl': environment.konghost + '/' + this.selectedVersion + '/' + this.partner + '/' + this.account + '/' + this.executor_name,
          'dataroot': null,
          'responseAttributes': null,
          'attributeMappings': null,
          'response': null,
          'block_attributes': this.attributeList
        };
        if (this.prerequisites !== null && this.prerequisites !== undefined) {
          fabResult['prerequisites'] = this.prerequisites;
        }

        fabResult['authModel'] = this.devexHeader.authModel1.getAuthModel();

        if (this.emitSaveApi) {
          this.saveBlocks.emit(fabResult);
        } else {
          const savePayload = {
            partner: '',
            account: '',
            executor_name: '',
            executor_type: '',
            by: '',
            executor_version: '',
            action: ''
          };

          savePayload.partner = this.partner;
          savePayload.account = this.account_id;
          savePayload['at'] = Date.now();
          savePayload.by = this.partner;

          if (this.executor_name !== null && this.executor_name !== undefined && this.executor_name !== '') {
            savePayload.executor_name = this.executor_name;
          } else {
            savePayload.executor_name = Date.now().toString();
          }

          if (this.selectedVersion !== null && this.selectedVersion !== undefined && this.selectedVersion !== '') {
            savePayload.executor_version = this.selectedVersion;
          } else {
            savePayload.executor_version = 'No Ver.';
          }
          if (this.editFlag) {
            savePayload.action = 'UPDATE';
          } else {
            savePayload.action = 'CREATE';
          }
          savePayload.executor_type = 'BUSINESSLOGIC';

          savePayload['executor'] = fabResult;
          const temp = JSON.parse(JSON.stringify(savePayload['executor']));
          let isSame = true;
          if (this.previousSavedData !== undefined && this.previousSavedData !== null) {
            if (Object.keys(this.previousSavedData).length === Object.keys(temp).length) {
              const keyArray = Object.keys(this.previousSavedData);
              for (const key of keyArray) {
                if (JSON.stringify(this.previousSavedData[key]) === JSON.stringify(temp[key])) {
                  continue;
                } else {
                  isSame = false;
                  break;
                }
              }
            } else {
              isSame = false;
            }
          } else {
            isSame = false;
          }

          if (isSame === false) {
            this.previousSavedData = JSON.parse(JSON.stringify(savePayload['executor']));
            this.cfgSrv.saveExecutorInformation('v1', savePayload).subscribe(data => {
              Promise.resolve(this.platform.generateActionPayloadForAudit(false, saveSuccessMessage, 'INFO', data.status, data.statusText, '', savePayload, data, this.router.url)).then(response => {
                const payloadToSend = {
                  actions: response
                };
                this.businessLogicListenerInstance.businessLogicListener.emit({
                  type: 'audit',
                  id: localStorage.getItem('IdOfSession'),
                  payload: payloadToSend
                });
              });
              this.platform.openSnackBar('API has been saved successfully.', 'Success', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              this.leftPanelDataListener.saveEntityAndExecutors.emit('success');
            }, error => {
              Promise.resolve(this.platform.generateActionPayloadForAudit(true, saveFailureMessage, 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), savePayload, error, this.router.url)).then(response => {
                const payloadToSend = {
                  actions: response
                };
                this.businessLogicListenerInstance.businessLogicListener.emit({
                  type: 'audit',
                  id: localStorage.getItem('IdOfSession'),
                  payload: payloadToSend
                });
              });
              this.platform.openSnackBar('Error while saving the API. Please try again after sometime.', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            });
          } else {
            this.platform.openSnackBar('No changes to save for this Business Logic API.', 'Error', {
              duration: 10000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          }
        }
      });
    }
  }

  checkForExistingEntityAndExecutorFromFocusOut() {
    setTimeout(() => {
      this.checkForExistingEntityAndExecutor();
    }, 2000);
  }

  CheckForExistingEntityOrExecutor() {
    return new Promise((resolve, reject) => {
      Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(this.executor_name, this.selectedVersion)).then(response => {
        this.isAPIAlreadyPresent = false;
        this.isAPIAlreadyPresentCheckCompleted = false;
        this.previouslyCheckedName = this.executor_name;
        this.previouslyCheckedVersion = this.selectedVersion;
        resolve('success');
      }, error => {
        if (error && error.status) {
          if (error.status === 'already exists') {
            this.isAPIAlreadyPresent = true;
            this.isAPIAlreadyPresentCheckCompleted = false;
            this.previouslyCheckedName = this.executor_name;
            this.previouslyCheckedVersion = this.selectedVersion;
            resolve('failed');
            this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
              duration: 10000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          } else if (error.status === 'failed') {
            this.isAPIAlreadyPresent = true;
            this.isAPIAlreadyPresentCheckCompleted = false;
            this.previouslyCheckedName = this.executor_name;
            this.previouslyCheckedVersion = this.selectedVersion;
            resolve('failed');
            this.platform.openSnackBar('Error occurred while checking your existing API information. Please try again after sometime.', 'Error', {
              duration: 10000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          }
        }
      });
    });
  }

  checkForExistingEntityAndExecutor() {
    return new Promise(async (resolve, reject) => {
      if (this.executor_name !== null && this.executor_name !== undefined && this.executor_name !== '' && this.selectedVersion !== null && this.selectedVersion !== undefined && this.selectedVersion !== '') {
        if (this.isAPIAlreadyPresentCheckCompleted === false) {
          if (this.previouslyCheckedName !== undefined && this.previouslyCheckedName !== null && this.previouslyCheckedVersion !== undefined && this.previouslyCheckedVersion !== null) {
            if (this.editFlag === true) {
              if (this.executor_name !== this.orig_executor_name || this.selectedVersion !== this.orig_executor_version) {
                if (this.previouslyCheckedName !== this.executor_name || this.previouslyCheckedVersion !== this.selectedVersion) {
                  this.isAPIAlreadyPresentCheckCompleted = true;
                  await this.CheckForExistingEntityOrExecutor();
                  resolve('success');
                } else {
                  resolve('success');
                }
              } else {
                resolve('success');
              }
            } else {
              if (this.previouslyCheckedName !== this.executor_name || this.previouslyCheckedVersion !== this.selectedVersion) {
                this.isAPIAlreadyPresentCheckCompleted = true;
                await this.CheckForExistingEntityOrExecutor();
                resolve('success');
              } else {
                resolve('success');
              }
            }
          } else {
            this.isAPIAlreadyPresentCheckCompleted = true;
            await this.CheckForExistingEntityOrExecutor();
            resolve('success');
          }
        } else {
          resolve('success');
        }
      }
    });
  }

  toggleDebugger() {
    this.debugFlag = false;
    this.blocklyDivSize = 'col-lg-12 col-md-12 col-sm-12 col-xs-12';
  }

  getTitleForVariable(variable){
    if (variable.executor_name !== null && variable.executor_name !== undefined) {
      if (variable.executor_version !== null && variable.executor_version !== undefined) {
        return variable.executor_name + '(' + variable.executor_version + ')';
      }
      return variable.executor_name;
    } else {
      return variable.name;
    }

  }
  async executeLocally(executor) {
    return new Promise(async (resolve, reject) => {

      await this._service.debugBusinessLogic(this.partner, this.account_id, executor).subscribe(response => {
        this.debugVariables = [];
        this.debugResults = response;
        var errorKey = '';
        if (this.debugResults) {
          this.inputSet = this.debugResults.inputSet;
          this.results = this.debugResults.results;
          this.isError = this.debugResults.isError;
          this.logText = this.debugResults.logText;

          if (this.isError && this.debugResults.errorStackTrace !== undefined && this.debugResults.errorStackTrace !== null) {
            this.errorStackTrace = this.debugResults.errorStackTrace;
          }
          if (this.isError && this.debugResults.errorClass !== undefined && this.debugResults.errorClass !== null) {
            this.errorClass = this.debugResults.errorClass;
          }
          if (this.isError && this.debugResults.errorMessage !== undefined && this.debugResults.errorMessage !== null) {
            this.errorMessage = this.debugResults.errorMessage;
          }
          const keys = Object.keys(this.results);
          keys.forEach(key => {
            const result = this.results[key];
            const statusCode = result['statusCode'];
            if (statusCode > 300) {
              this.debugErrorFlag = true;
              errorKey = key;
              if (this.debugErrorFlag && result.body) {
                this.errorMessage = result.body;
              }
            }
            this.debugVariables.push({'name': key, 'message': JSON.stringify(this.results[key]), 'responses': this.results[key]});
          });

          if (!this.isError && !this.debugErrorFlag) {
            this.debugResult = this.debugResult.concat(this.logText);
            this.debugResult = this.debugResult.concat('<br/>');
          } else {
            this.debugResult = this.debugResult.concat(this.logText);
            this.debugResult = this.debugResult.concat('<br/>');
            // this.debugResult = this.debugResult.concat('<p style="color: red"><b>' + 'Error while executing the block: ' + errorKey + '</b></p>');
            this.debugResult = this.debugResult.concat('<p style="color: red">' + this.errorMessage + '</p>');
            if (this.errorStackTrace && this.errorStackTrace !== null && this.errorStackTrace !== undefined) {
              this.debugResult = this.debugResult.concat(JSON.stringify(this.errorStackTrace));
              this.debugResult = this.debugResult.concat('<br/>');
            }
          }
          resolve(response);
        }


      }, error => {
        this.executeFlagLocally = false;
        const result = {
          'executor_type': executor.executor_type !== null ? executor.executor_type : '',
          'executor_name': executor.executor_name !== null ? executor.executor_name : '',
          'executor_version': executor.executor_version !== null ? executor.executor_version : '',
          'executor_category': executor.executor_category !== null ? executor.executor_category : '',
          'name': 'response',
          'timestamp': error.error.timestamp,
          'status': error.error.status,
          'error': error.error.error,
          'message': '<p style="color: red">' + 'Code: ' + error.error.status + ' : Error: ' + error.error.error + ' : Message: ' + error.error.message + '</p>'
        };

        this.debugVariables.push(result);
        this.debugResult = this.debugResult.concat('<br/>');
        this.debugResult = this.debugResult.concat('Error while executing block:');
        this.debugResult = this.debugResult.concat('<br/>');
        this.debugResult = this.debugResult.concat('<p style="color: red">' + 'Code: ' + error.error.status + ' : Error: ' + error.error.error + ' : Message: ' + error.error.message + '</p>');
        this.debugErrorFlag = true;
        resolve(result);
      });

    });
  }

  generateExecutorForDebug() {
    this.debugErrorFlag = false;
    this.debugVariables = [];
    this.debugResult = '';

    this.inputSet = {};
    this.results = {};

    let methodType = 'GET';
    let executorName = 'test';
    let version = 'v1';
    if (this.selectedExecutor !== null && this.selectedExecutor !== undefined && this.selectedExecutor !== '') {
      methodType = this.selectedExecutor;
    }
    if (this.executor_name !== null && this.executor_name !== undefined && this.executor_name !== '') {
      executorName = this.executor_name;
    }
    if (this.selectedVersion !== null && this.selectedVersion !== undefined && this.selectedVersion !== '') {
      version = this.selectedVersion;
    }

    this.inputSet['platformAPIDetails'] = {
      methodType: methodType,
      name: executorName,
      type: 'BUSINESSLOGIC',
      version: version
    }

    let inputHeaders = {};
    let inputParameters = {};
    let inputRequestBody = {};
    this.requestBody = this.devexHeader.getRequestBody();
    if (this.headers && this.headers !== null && this.headers !== undefined) {
      for (let i = 0; i < this.headers.length; i++) {
        if (this.headers[i] && this.headers[i] !== null && this.headers[i] !== undefined) {
          if (this.headers[i]['key'] === '') {
            this.headers.splice(i, 1);
          } else {
            inputHeaders[this.headers[i].key.toLowerCase()] = this.headers[i]['value'];
          }
        }
      }
    }
    if (this.queryParams && this.queryParams !== null && this.queryParams !== undefined) {
      for (let i = 0; i < this.queryParams.length; i++) {
        if (this.queryParams[i] && this.queryParams[i] !== null && this.queryParams[i] !== undefined) {
          if (this.queryParams[i]['key'] === '') {
            this.queryParams.splice(i, 1);
          } else {
            inputParameters[this.queryParams[i].key] = this.queryParams[i]['value'];
          }
        }
      }
    }
    if (this.devexHeader.requestBodySelected && this.devexHeader.requestBodySelected !== 'raw' && this.devexHeader.requestBodySelected !== 'binary' && this.devexHeader.requestBodySelected !== 'none') {
      if (this.requestBody.hasOwnProperty('__zone_symbol__value')) {
        this.requestBody = this.requestBody['__zone_symbol__value'];
      }
      if (this.requestBody && this.requestBody !== null && this.requestBody !== undefined && this.requestBody['value']) {
        for (let i = 0; i < this.requestBody['value'].length; i++) {
          // let requestBody = {};
          if (this.requestBody['value'] && this.requestBody['value'][i] && this.requestBody['value'][i] !== null && this.requestBody['value'][i] !== undefined) {
            if (this.requestBody['value'][i]['key'] === '') {
              this.requestBody['value'].splice(i, 1);
            } else {
              inputRequestBody[this.requestBody['value'][i].key] = this.requestBody['value'][i]['value'];
            }
          }
        }
        this.inputSet['Payload'] = inputRequestBody;
      }
    } else {
      // inputRequestBody[this.requestBody['key']] = this.requestBody['value'];
      if (this.requestBody.hasOwnProperty('__zone_symbol__value')) {
        this.requestBody = this.requestBody['__zone_symbol__value'];
      }
      if (this.requestBody && this.requestBody !== null && this.requestBody !== undefined && this.requestBody['value']) {
        this.inputSet['Payload'] = this.requestBody['value'];
      } else {
        this.inputSet['Payload'] = {};
      }
    }

    this.inputSet['headers'] = inputHeaders;
    this.inputSet['queryParams'] = inputParameters;

    return new Promise(async (resolve, reject) => {

      this.debugResult = 'Reading the blocks...'
      var that = this;
      var xml = Blockly.Xml.workspaceToDom(this.workspace);
      var rootNode = xml.getRootNode();

      var idsTobeRemoved = [];
      const blocks = rootNode.childNodes;
      blocks.forEach(blk => {
        if (blk.getAttribute('type') === 'json_object' ||
            blk.getAttribute('type') === 'text' ||
            blk.getAttribute('type') === 'basic_authentication' ||
            blk.getAttribute('type') === 'digest_authentication' ||
            blk.getAttribute('type') === 'connector' ||
            blk.getAttribute('type') === 'api_key' ||
            blk.getAttribute('type') === 'bearer_token' ||
            blk.getAttribute('type') === 'aws' ||
            blk.getAttribute('type') === 'oauth_1_0' ||
            blk.getAttribute('type') === 'oauth_2_0') {
          idsTobeRemoved.push(blk.getAttribute('id'));
        }
      });

      idsTobeRemoved.forEach(id => {
        var children = rootNode.childNodes;
        children.forEach(child => {
          if (id === child.getAttribute('id')) {
            rootNode.removeChild(child);
          }
        });
      });

      var xml_text = Blockly.Xml.domToText(rootNode);
      const parser = new DOMParser();
      const xml1 = parser.parseFromString(xml_text, 'text/xml');
      const obj = this.ngxXml2jsonService.xmlToJson(xml1);

      if (obj['xml'].block === undefined) {
        this.platform.openSnackBar('The business logic is empty. Please add some blocks to test this logic as an API', 'Error', {
          duration: 10000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.loading1 = false;
      } else {
        this.debugFlag = true;
        this.executeFlagLocally = true;
        if (this.debugFlag) {
          this.blocklyDivSize = 'col-lg-9 col-md-9 col-sm-12 col-xs-12';
        } else {
          this.blocklyDivSize = 'col-lg-12 col-md-12 col-sm-12 col-xs-12';
        }
        let JSON_Blocks = {};
        if (obj['xml'] && obj['xml'].block && obj['xml'].block.length > 1) {
          let index = 0;

          obj['xml'].block.forEach((block) => {
            if (block['@attributes'].type !== 'text' &&
                block['@attributes'].type !== 'json_object' &&
                block['@attributes'].type !== 'basic_authentication' &&
                block['@attributes'].type !== 'digest_authentication' &&
                block['@attributes'].type !== 'connector' &&
                block['@attributes'].type !== 'api_key' &&
                block['@attributes'].type !== 'bearer_token' &&
                block['@attributes'].type !== 'aws' &&
                block['@attributes'].type !== 'oauth_1_0' &&
                block['@attributes'].type !== 'oauth_2_0') {
              JSON_Blocks['block'] = obj['xml'].block[index];
            }
            index++;
          });
        } else {
          JSON_Blocks['block'] = obj['xml'].block;
        }
        this.debugResult = this.debugResult.concat('Done');
        this.debugResult = this.debugResult.concat('<br/>');
        this.debugResult = this.debugResult.concat('Generating executors for the blocks...');
        this.cfgSrv.getExecutorsForBlocks(this.partner, this.account_id, JSON_Blocks).subscribe(async (executors) => {
          if (executors) {
            this.executorBlocks = executors;
            this.debugResult = this.debugResult.concat('Done');
            this.debugResult = this.debugResult.concat('<br/>');

            for (const executor of this.executorBlocks) {

              const executorPayload = {
                'parentWorkflow': '',
                'inputSet': this.inputSet,
                'results': this.results,
                'statement': executor
              };
              await this.executeLocally(executorPayload);
              // if (this.debugErrorFlag) {
              //     this.executeFlagLocally = false;
              //     return;
              // }
            }
          } else {
            this.debugResult = this.debugResult.concat('<p style="color: red"> There is no block to run....</p>>');
            this.debugResult = this.debugResult.concat('<br/>');

          }
          this.executeFlagLocally = false;


        }, error => {
          this.executeFlagLocally = false;
          let errorMessage = '';
          if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
            errorMessage = error.error.message;
          } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
            errorMessage = error.error;
          } else {
            errorMessage = 'Error occurred while debugging your business logic API. Please try again after sometime.';
          }
          this.platform.openSnackBar(errorMessage, 'Error', {
            duration: 15000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        });
      }
    });

  }

  findExecutorAttibutes(category, executor) {
    const catIndex = this.items.findIndex(c => c.category === category);
    const that = this;
    const fdata = this.items[catIndex].executors.findIndex(p => p && p.executor_type+'_'+p.executor_name+'_'+p.executor_version === executor.trim());

    const data = this.items[catIndex].executors[fdata];

    if (data && data.responseAttributes) {
      data.responseAttributes.forEach((attr) => {
        if (attr !== 'undefined' || attr != null) {
          that.getNodeAttributes(executor, attr);
        }
      });
      for (const item of that.firstOfBody) {
        if (item) {
          that.attributeList.push(item);
        }
      }
      that.firstOfBody = [];
    }
    if (data && (data.responseAttributes === null || data.responseAttributes.length === 0)) {

      if(that.attributeList){
        if (that.attributeList.findIndex(p => p[0] === executor + '>response') === -1) {
          that.attributeList.push([executor + '>response', executor + '>response']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>response.statusCode') === -1) {
          that.attributeList.push([executor + '>response.statusCode', executor + '>response.statusCode']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>response.body') === -1) {
          that.attributeList.push([executor + '>response.body', executor + '>response.body']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>response.body._isList') === -1) {
          that.attributeList.push([executor + '>response.body._isList', executor + '>response.body._isList']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>response.headers') === -1) {
          that.attributeList.push([executor + '>response.headers', executor + '>response.headers']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>API.name') === -1) {
          that.attributeList.push([executor + '>API.name', executor + '>API.name']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>API.version') === -1) {
          that.attributeList.push([executor + '>API.version', executor + '>API.version']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>API.methodType') === -1) {
          that.attributeList.push([executor + '>API.methodType', executor + '>API.methodType']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>API.type') === -1) {
          that.attributeList.push([executor + '>API.type', executor + '>API.type']);
        }
      }
    }
  }
  findExecutorAttibutesforB2B(category, executor) {
    let catIndex: any;
    this.apiResponseFromServerForB2B.forEach((provider) => {
      catIndex = provider.categories.findIndex(c => c.category === category);
    });

    let data: any;
    let fdata: any;
    const that = this;

    if (this.apiResponseFromServerForB2B && this.apiResponseFromServerForB2B !== undefined && this.apiResponseFromServerForB2B !== null) {
      this.apiResponseFromServerForB2B.forEach((b2b) => {
        if (b2b && b2b !== null && b2b !== undefined && b2b.categories && b2b.categories !== null && b2b.categories !== undefined) {
          b2b.categories.forEach((cat) => {
            if (cat && cat.category && cat.category !== null && cat.category !== undefined) {
              if (cat.category === category.category) {
                fdata = cat['executors'].findIndex(p => p && p.executor_type+'_'+p.executor_name+'_'+p.executor_version === executor.trim());
                data = cat['executors'][fdata];
                if (data && data.responseAttributes && data.responseAttributes !== null && data.responseAttributes !== undefined) {
                  data.responseAttributes.forEach((attr) => {
                    if (attr !== 'undefined' || attr != null) {
                      that.getNodeAttributes(executor, attr);
                    }
                  });
                  for (const item of that.firstOfBody) {
                    if (item) {
                      that.attributeList.push(item);
                    }
                  }
                  that.firstOfBody = [];
                }
              }
            }
          });
        }
      });
    }

    if (this.apiResponseFromServerForMyProviders && this.apiResponseFromServerForMyProviders !== undefined && this.apiResponseFromServerForMyProviders !== null) {
      this.apiResponseFromServerForMyProviders.forEach((myProvider) => {
        if (myProvider && myProvider !== null && myProvider !== undefined && myProvider.categories && myProvider.categories !== null && myProvider.categories !== undefined) {
          myProvider.categories.forEach((cat) => {
            if (cat && cat.category && cat.category !== null && cat.category !== undefined) {
              if (cat.category === category.category) {
                fdata = cat['executors'].findIndex(p => p && p.executor_type+'_'+p.executor_name+'_'+p.executor_version === executor.trim());
                data = cat['executors'][fdata];
                if (data && data.responseAttributes && data.responseAttributes !== null && data.responseAttributes !== undefined) {
                  data.responseAttributes.forEach((attr) => {
                    if (attr !== 'undefined' || attr != null) {
                      that.getNodeAttributes(executor, attr);
                    }
                  });
                  for (const item of that.firstOfBody) {
                    if (item) {
                      that.attributeList.push(item);
                    }
                  }
                  that.firstOfBody = [];
                }
              }
            }
          });
        }
      });
    }

    if (data && data.responseAttributes) {
      data.responseAttributes.forEach((attr) => {
        if (attr !== 'undefined' || attr != null) {
          that.getNodeAttributes(executor, attr);
        }
      });
      for (const item of that.firstOfBody) {
        if (item) {
          that.attributeList.push(item);
        }
      }
      that.firstOfBody = [];
    }
    if (data && (data.responseAttributes === null || data.responseAttributes === undefined || data.responseAttributes.length === 0)) {
      if(that.attributeList){
        if (that.attributeList.findIndex(p => p[0] === executor + '>response') === -1) {
          that.attributeList.push([executor + '>response', executor + '>response']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>response.statusCode') === -1) {
          that.attributeList.push([executor + '>response.statusCode', executor + '>response.statusCode']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>response.body') === -1) {
          that.attributeList.push([executor + '>response.body', executor + '>response.body']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>response.body._isList') === -1) {
          that.attributeList.push([executor + '>response.body._isList', executor + '>response.body._isList']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>response.headers') === -1) {
          that.attributeList.push([executor + '>response.headers', executor + '>response.headers']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>API.name') === -1) {
          that.attributeList.push([executor + '>API.name', executor + '>API.name']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>API.version') === -1) {
          that.attributeList.push([executor + '>API.version', executor + '>API.version']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>API.methodType') === -1) {
          that.attributeList.push([executor + '>API.methodType', executor + '>API.methodType']);
        }
        if (that.attributeList.findIndex(p => p[0] === executor + '>API.type') === -1) {
          that.attributeList.push([executor + '>API.type', executor + '>API.type']);
        }
      }
    }
  }
  getNodeAttributes(exName, data) {
    const that = this;
    if(that.attributeList){
      if (that.attributeList.findIndex(p => p[0] === exName + '>response') === -1) {
        that.attributeList.push([exName + '>response', exName + '>response']);
      }
      if (that.attributeList.findIndex(p => p[0] === exName + '>response.statusCode') === -1) {
        that.attributeList.push([exName + '>response.statusCode', exName + '>response.statusCode']);
      }
      if (that.attributeList.findIndex(p => p[0] === exName + '>response.body') === -1) {
        that.attributeList.push([exName + '>response.body', exName + '>response.body']);
      }
      if (that.attributeList.findIndex(p => p[0] === exName + '>response.body._isList') === -1) {
        that.attributeList.push([exName + '>response.body._isList', exName + '>response.body._isList']);
      }
      if (that.attributeList.findIndex(p => p[0] === exName + '>response.headers') === -1) {
        that.attributeList.push([exName + '>response.headers', exName + '>response.headers']);
      }
      if (that.attributeList.findIndex(p => p[0] === exName + '>API.name') === -1) {
        that.attributeList.push([exName + '>API.name', exName + '>API.name']);
      }
      if (that.attributeList.findIndex(p => p[0] === exName + '>API.version') === -1) {
        that.attributeList.push([exName + '>API.version', exName + '>API.version']);
      }
      if (that.attributeList.findIndex(p => p[0] === exName + '>API.methodType') === -1) {
        that.attributeList.push([exName + '>API.methodType', exName + '>API.methodType']);
      }
      if (that.attributeList.findIndex(p => p[0] === exName + '>API.type') === -1) {
        that.attributeList.push([exName + '>API.type', exName + '>API.type']);
      }
      if (data.attributeName !== null) {
        if (data.subType == null || data.subType.length === 0) {
          const ind = that.attributeList.findIndex(p => p[0] === exName + '>' + data.attributeName);
          if (ind === -1) {
            that.attributeList.push([exName + '>' + data.attributeName, exName + '>' + data.attributeName]);
          }
          const ind1 = that.attributeList.findIndex(p => p[0] === exName + '>response.body._first>' + data.attributeName);
          if (ind1 === -1) {
            that.firstOfBody.push([exName + '>response.body._first>' + data.attributeName, exName + '>response.body._first>' + data.attributeName]);
          }
        } else {
          data.subType.forEach((sub) => {
            if (data.subType == null || data.subType.length === 0) {
              const ind = that.attributeList.findIndex(p => p[0] === exName + '>' + data.attributeName + '.' + sub.attributeName);
              if (ind === -1) {
                that.attributeList.push([exName + '>' + data.attributeName + '.' + sub.attributeName, exName + '>' + data.attributeName + '.' + sub.attributeName]);
              }
              const ind1 = that.attributeList.findIndex(p => p[0] === exName + '>response.body._first>' + data.attributeName + '.' + sub.attributeName);
              if (ind1 === -1) {
                that.firstOfBody.push([exName + '>response.body._first>' + data.attributeName + '.' + sub.attributeName, exName + '>response.body._first>' + data.attributeName + '.' + sub.attributeName]);
              }
            } else {
              that.getLeafAttributes(exName + '>' + data.attributeName, sub);
            }
          });
        }

      }
    }
  }
  getLeafAttributes(parent, data) {
    const that = this;
    if (data.subType == null || data.subType.length === 0) {
      const ind = that.attributeList.findIndex(p => p[0] === parent + '.' + data.attributeName);
      if (ind === -1 && data.attributeName !== null) {
        that.attributeList.push([parent + '.' + data.attributeName, parent + '.' + data.attributeName]);
      }
    } else {
      data.subType.forEach((sub) => {
        if (data.subType == null || data.subType.length === 0) {
          const ind = that.attributeList.findIndex(p => p[0] === parent + '.' + data.attributeName + '.' + sub.attributeName);
          if (ind === -1 && sub.attributeName !== null) {
            that.attributeList.push([parent + '.' + data.attributeName + '.' + sub.attributeName,
              parent + '.' + data.attributeName + '.' + sub.attributeName]);
          }
        } else {
          that.getLeafAttributes(parent + '.' + data.attributeName, sub);
        }
      });
    }
  }

  displayFn(user?: ICategory): string | undefined {
    return user ? user.name : undefined;
  }

  toggleExecutor1(ev) {
    if (ev === 'DELETE') {
      if (this.isToggleExpanded === true) {
        this.isToggleExpanded = false;
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
      }
    } else {
      if (this.isToggleExpanded === false) {
        this.isToggleExpanded = true;
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
      }
    }
  }

  toggleExecutor(ev) {
    this.isToggleExpanded = !this.isToggleExpanded;
    $('.executor-definition').slideToggle();
    $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
  }
  searchBlock() {
    const item = [...this.items];
    const that = this;
    item.forEach((result) => {
      result.executors.filter(function (data) {
        data.toLowerCase().indexOf(that.searchAPI) > -1;
      });
    });

  }
  setInterval(blockEnd, nextPanel) {
    this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
  }
  ngOnDestroy() {
    clearInterval(this.destroy);
  }

  generateExecutorAgain() {
    window.location.reload();
  }
}
